 
export const WebDesigning = [
    {
        id: "1",
        small_text: "Start your career as a web Designer",
        name: "Web designing course in kurukshetra",
        duration_One : "6 Months",
        description: "In today's digital world, there's a growing need for skilled web designers. At BrainboxStudy, we understand this demand and provide thorough training in web design. Our goal is to give you the essential skills you need for a successful career in this exciting and rapidly evolving field. Join us and start building your future today!",
        image: "/webdesigns.png",
        join_btn: "Join Now",
        alt: "web desgin"
    },
    {
        id: "2",
        main_image: "https://img.freepik.com/free-photo/web-design-technology-browsing-programming-concept_53876-163260.jpg?size=626&ext=jpg&ga=GA1.1.2008272138.1720656000&semt=ais_user",
        small_text_one: "Web Designing Course",
        title: "Web Designing Course: Why Choose This Career?",
        desc: "In today's digital world, web design is crucial for modern businesses and communication. As everyone aims to build an online presence, the need for skilled web designers is growing rapidly. This career combines creativity and technical skills, allowing you to shape the websites and apps we use every day. Our Web Designing Course in Chandigarh is perfect for those who want to lead in this exciting field. Whether you're a new graduate or changing careers, web design has many benefits. It offers high-paying jobs, constant innovation, and the flexibility to work in various industries. As companies see the value of good user experience and attractive websites, web designers become essential for driving engagement and success.",
        visit_btn: " Visit the help center",
        alt : "Web Designing"
    },
    {
        id: "3",
        title: "Why Choose BrainboxStudy for Web Designing?",
        sub_title: "Find the best path to becoming a skilled web designer with our industry-aligned courses.",
        feature: [
            {
                id: "1",
                icon: ( <svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M0.849976 1.74998C0.849976 1.25292 1.25292 0.849976 1.74998 0.849976H3.24998C3.74703 0.849976 4.14998 1.25292 4.14998 1.74998V2.04998H10.85V1.74998C10.85 1.25292 11.2529 0.849976 11.75 0.849976H13.25C13.747 0.849976 14.15 1.25292 14.15 1.74998V3.24998C14.15 3.74703 13.747 4.14998 13.25 4.14998H12.95V10.85H13.25C13.747 10.85 14.15 11.2529 14.15 11.75V13.25C14.15 13.747 13.747 14.15 13.25 14.15H11.75C11.2529 14.15 10.85 13.747 10.85 13.25V12.95H4.14998V13.25C4.14998 13.747 3.74703 14.15 3.24998 14.15H1.74998C1.25292 14.15 0.849976 13.747 0.849976 13.25V11.75C0.849976 11.2529 1.25292 10.85 1.74998 10.85H2.04998V4.14998H1.74998C1.25292 4.14998 0.849976 3.74703 0.849976 3.24998V1.74998ZM2.94998 4.14998V10.85H3.24998C3.74703 10.85 4.14998 11.2529 4.14998 11.75V12.05H10.85V11.75C10.85 11.2529 11.2529 10.85 11.75 10.85H12.05V4.14998H11.75C11.2529 4.14998 10.85 3.74703 10.85 3.24998V2.94998H4.14998V3.24998C4.14998 3.74703 3.74703 4.14998 3.24998 4.14998H2.94998ZM2.34998 1.74998H1.74998V2.34998V2.64998V3.24998H2.34998H2.64998H3.24998V2.64998V2.34998V1.74998H2.64998H2.34998ZM5.09998 5.99998C5.09998 5.50292 5.50292 5.09998 5.99998 5.09998H6.99998C7.49703 5.09998 7.89998 5.50292 7.89998 5.99998V6.99998C7.89998 7.03591 7.89787 7.07134 7.89378 7.10618C7.92861 7.10208 7.96405 7.09998 7.99998 7.09998H8.99998C9.49703 7.09998 9.89998 7.50292 9.89998 7.99998V8.99998C9.89998 9.49703 9.49703 9.89998 8.99998 9.89998H7.99998C7.50292 9.89998 7.09998 9.49703 7.09998 8.99998V7.99998C7.09998 7.96405 7.10208 7.92861 7.10618 7.89378C7.07134 7.89787 7.03591 7.89998 6.99998 7.89998H5.99998C5.50292 7.89998 5.09998 7.49703 5.09998 6.99998V5.99998ZM6.09998 5.99998H5.99998V6.09998V6.89998V6.99998H6.09998H6.89998H6.99998V6.89998V6.09998V5.99998H6.89998H6.09998ZM7.99998 7.99998H8.09998H8.89998H8.99998V8.09998V8.89998V8.99998H8.89998H8.09998H7.99998V8.89998V8.09998V7.99998ZM2.64998 11.75H2.34998H1.74998V12.35V12.65V13.25H2.34998H2.64998H3.24998V12.65V12.35V11.75H2.64998ZM11.75 1.74998H12.35H12.65H13.25V2.34998V2.64998V3.24998H12.65H12.35H11.75V2.64998V2.34998V1.74998ZM12.65 11.75H12.35H11.75V12.35V12.65V13.25H12.35H12.65H13.25V12.65V12.35V11.75H12.65Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Expert Faculty",
                desc: "Learn from seasoned professionals with extensive industry experience."
            },
            {
                id: "2",
                icon: ( <svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M3.00014 2.73895C3.00014 2.94698 2.76087 3.06401 2.59666 2.93628L1.00386 1.69744C0.875177 1.59735 0.875177 1.40286 1.00386 1.30277L2.59666 0.063928C2.76087 -0.0637944 3.00014 0.0532293 3.00014 0.261266V1.00012H9.00009V0.261296C9.00009 0.0532591 9.23936 -0.0637646 9.40358 0.0639578L10.9964 1.3028C11.1251 1.40289 11.1251 1.59738 10.9964 1.69747L9.40358 2.93631C9.23936 3.06404 9.00009 2.94701 9.00009 2.73898V2.00012H3.00014V2.73895ZM9.50002 4.99998H2.50002C2.22388 4.99998 2.00002 5.22384 2.00002 5.49998V12.5C2.00002 12.7761 2.22388 13 2.50002 13H9.50002C9.77616 13 10 12.7761 10 12.5V5.49998C10 5.22384 9.77616 4.99998 9.50002 4.99998ZM2.50002 3.99998C1.67159 3.99998 1.00002 4.67156 1.00002 5.49998V12.5C1.00002 13.3284 1.67159 14 2.50002 14H9.50002C10.3284 14 11 13.3284 11 12.5V5.49998C11 4.67156 10.3284 3.99998 9.50002 3.99998H2.50002ZM14.7389 6.00001H14V12H14.7389C14.9469 12 15.064 12.2393 14.9362 12.4035L13.6974 13.9963C13.5973 14.125 13.4028 14.125 13.3027 13.9963L12.0639 12.4035C11.9362 12.2393 12.0532 12 12.2612 12H13V6.00001H12.2612C12.0532 6.00001 11.9361 5.76074 12.0639 5.59653L13.3027 4.00373C13.4028 3.87505 13.5973 3.87505 13.6974 4.00374L14.9362 5.59653C15.0639 5.76074 14.9469 6.00001 14.7389 6.00001Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Comprehensive Curriculum",
                desc: "Gain practical skills through a curriculum designed to meet current industry demands."
            },
            {
                id: "3",
                icon: (<svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M1 2C0.447715 2 0 2.44772 0 3V12C0 12.5523 0.447715 13 1 13H14C14.5523 13 15 12.5523 15 12V3C15 2.44772 14.5523 2 14 2H1ZM1 3L14 3V3.92494C13.9174 3.92486 13.8338 3.94751 13.7589 3.99505L7.5 7.96703L1.24112 3.99505C1.16621 3.94751 1.0826 3.92486 1 3.92494V3ZM1 4.90797V12H14V4.90797L7.74112 8.87995C7.59394 8.97335 7.40606 8.97335 7.25888 8.87995L1 4.90797Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Career Support",
                desc: "Access job placement assistance, portfolio building guidance, and networking opportunities."
            },
            {
                id: "4",
                icon: ( <svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M4.5 2C3.11929 2 2 3.11929 2 4.5C2 5.88072 3.11929 7 4.5 7C5.88072 7 7 5.88072 7 4.5C7 3.11929 5.88072 2 4.5 2ZM3 4.5C3 3.67157 3.67157 3 4.5 3C5.32843 3 6 3.67157 6 4.5C6 5.32843 5.32843 6 4.5 6C3.67157 6 3 5.32843 3 4.5ZM10.5 2C9.11929 2 8 3.11929 8 4.5C8 5.88072 9.11929 7 10.5 7C11.8807 7 13 5.88072 13 4.5C13 3.11929 11.8807 2 10.5 2ZM9 4.5C9 3.67157 9.67157 3 10.5 3C11.3284 3 12 3.67157 12 4.5C12 5.32843 11.3284 6 10.5 6C9.67157 6 9 5.32843 9 4.5ZM2 10.5C2 9.11929 3.11929 8 4.5 8C5.88072 8 7 9.11929 7 10.5C7 11.8807 5.88072 13 4.5 13C3.11929 13 2 11.8807 2 10.5ZM4.5 9C3.67157 9 3 9.67157 3 10.5C3 11.3284 3.67157 12 4.5 12C5.32843 12 6 11.3284 6 10.5C6 9.67157 5.32843 9 4.5 9ZM10.5 8C9.11929 8 8 9.11929 8 10.5C8 11.8807 9.11929 13 10.5 13C11.8807 13 13 11.8807 13 10.5C13 9.11929 11.8807 8 10.5 8ZM9 10.5C9 9.67157 9.67157 9 10.5 9C11.3284 9 12 9.67157 12 10.5C12 11.3284 11.3284 12 10.5 12C9.67157 12 9 11.3284 9 10.5Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Innovative Approach",
                desc: "Stay ahead with the latest tools and trends in web design through hands-on projects and workshops."
            },
            {
                id: "5",
                icon: (<svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M9.96424 2.68571C10.0668 2.42931 9.94209 2.13833 9.6857 2.03577C9.4293 1.93322 9.13832 2.05792 9.03576 2.31432L5.03576 12.3143C4.9332 12.5707 5.05791 12.8617 5.3143 12.9642C5.5707 13.0668 5.86168 12.9421 5.96424 12.6857L9.96424 2.68571ZM3.85355 5.14646C4.04882 5.34172 4.04882 5.6583 3.85355 5.85356L2.20711 7.50001L3.85355 9.14646C4.04882 9.34172 4.04882 9.6583 3.85355 9.85356C3.65829 10.0488 3.34171 10.0488 3.14645 9.85356L1.14645 7.85356C0.951184 7.6583 0.951184 7.34172 1.14645 7.14646L3.14645 5.14646C3.34171 4.9512 3.65829 4.9512 3.85355 5.14646ZM11.1464 5.14646C11.3417 4.9512 11.6583 4.9512 11.8536 5.14646L13.8536 7.14646C14.0488 7.34172 14.0488 7.6583 13.8536 7.85356L11.8536 9.85356C11.6583 10.0488 11.3417 10.0488 11.1464 9.85356C10.9512 9.6583 10.9512 9.34172 11.1464 9.14646L12.7929 7.50001L11.1464 5.85356C10.9512 5.6583 10.9512 5.34172 11.1464 5.14646Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Community Engagement",
                desc: " Connect with a vibrant community of learners and industry experts for collaborative learning and growth."
            },
            {
                id: "6",
                icon: ( <svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M7.28856 0.796908C7.42258 0.734364 7.57742 0.734364 7.71144 0.796908L13.7114 3.59691C13.8875 3.67906 14 3.85574 14 4.05V10.95C14 11.1443 13.8875 11.3209 13.7114 11.4031L7.71144 14.2031C7.57742 14.2656 7.42258 14.2656 7.28856 14.2031L1.28856 11.4031C1.11252 11.3209 1 11.1443 1 10.95V4.05C1 3.85574 1.11252 3.67906 1.28856 3.59691L7.28856 0.796908ZM2 4.80578L7 6.93078V12.9649L2 10.6316V4.80578ZM8 12.9649L13 10.6316V4.80578L8 6.93078V12.9649ZM7.5 6.05672L12.2719 4.02866L7.5 1.80176L2.72809 4.02866L7.5 6.05672Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Engaging Learning Environment",
                desc: "Enjoy our dedicated on-site facilities and in-person teaching for an interactive and hands-on learning experience."
            },
        ]
       
    },
    {
        id: "4",
        title: "What You'll Learn",
        sub_title:"Master essential web design skills and tools to create stunning, responsive websites that captivate and engage users.",
        Course_img: [
            {
                id: "1",
                img: "https://ideacdn.net/idea/ct/82/myassets/blogs/html-css.jpg?revision=1581690718",
                title: "HTML and CSS",
                alt: "CSS"
            },
            {
                id: "2",
                img: "https://beadgrup.com/news/wp-content/uploads/2021/02/icons-hero.png",
                title: "Boostrap",
                alt: "Boostrap"
            },
            {
                id: "4",
                img: "https://nilayinfotech.in/wp-content/uploads/2023/10/Wordpress.jpg",
                title: "Wordpress",
                alt: "Wordpress"
            },
        ]
    },
    {
        id: "5",
        title: "Frequently Asked Questions (FAQs)",
        sub_title: "Still have questions about our Web Designing course? We've got you covered. Check out these commonly asked questions to find the answers you need.",
        faqs: [
           {
            id: "1",
            heading: " Who is this course for?",
            sub_heading: "This course is designed for beginners with no prior experience in web design, as well as intermediate learners looking to enhance their skills and stay updated with the latest technologies.",
           },
           {
            id: "2",
            heading: " Do I need any special software or equipment?",
            sub_heading: "You'll need a computer with internet access. We recommend using a modern web browser. Most software we use is free or has free alternatives, but we'll provide a detailed list upon enrollment.",
           },
           {
            id: "3",
            heading: " How long does the course take to complete?",
            sub_heading: "The course is designed to be completed approx. 8 months, but you can learn at your own pace. You'll have lifetime access to the course materials.",
           },
           {
            id: "4",
            heading: " Is there a certificate upon completion?",
            sub_heading: "Yes, you'll receive a certificate of completion that you can add to your resume or LinkedIn profile.",
           },
           {
            id: "5",
            heading: "What if I have questions during the course?",
            sub_heading: "We offer weekly live Q&A sessions, a community forum, and email support to address any questions you may have.",
           },
        ]
    },
]


export const FullStack = [
    {
        id: "1",
        small_text: "Start your career as a Full-Stack Development",
        name: "Full-Stack Development course in kurukshetra",
        duration_One : "8 Months ",
        description: "In today's tech-driven world, there's a growing demand for developers who can handle both front-end and back-end technologies. At BrainboxStudy, we provide comprehensive training in full-stack development. Our aim is to equip you with the skills needed to excel in this dynamic and rewarding field. Join us and build a future-proof career in technology!",
        image: "/fullstack.png",
        join_btn: "Join Now",
        alt: "Full-Stack"
    },
    {
        id: "2",
        main_image: "https://oilab.in/public/img/courses/full-stack-web-developer.jpg",
        small_text_one: "Full-Stack Development Course",
        title: "Full-Stack Development Course In Kurukshetra: Why Choose This Career?",
        desc: "In the fast-evolving tech industry, full-stack development has become a highly valued skill. Businesses increasingly require seamless and efficient applications, driving the demand for developers who can manage all aspects of web development. This career path blends creativity with problem-solving, enabling you to bring ideas to life from concept to deployment. Our Full-Stack Development Course in Kurukshetra is ideal for those eager to lead in software development.Whether you're a recent graduate or a professional seeking to enhance your skills, full-stack development offers numerous benefits. It opens up lucrative job opportunities, ensures continuous learning, and allows you to work across various industries. As companies recognize the importance of developers who can oversee entire projects, full-stack developers play a pivotal role in driving innovation and success.",
        visit_btn: " Visit the help center",
        alt: "Full-Stack"
    },
    {
        id: "3",
        title: "Why Choose BrainboxStudy for Full-Stack Development?",
        sub_title: "Begin your journey to becoming a proficient full-stack developer with our industry-aligned courses.",
        feature: [
            {
                id: "1",
                icon: ( <svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M0.849976 1.74998C0.849976 1.25292 1.25292 0.849976 1.74998 0.849976H3.24998C3.74703 0.849976 4.14998 1.25292 4.14998 1.74998V2.04998H10.85V1.74998C10.85 1.25292 11.2529 0.849976 11.75 0.849976H13.25C13.747 0.849976 14.15 1.25292 14.15 1.74998V3.24998C14.15 3.74703 13.747 4.14998 13.25 4.14998H12.95V10.85H13.25C13.747 10.85 14.15 11.2529 14.15 11.75V13.25C14.15 13.747 13.747 14.15 13.25 14.15H11.75C11.2529 14.15 10.85 13.747 10.85 13.25V12.95H4.14998V13.25C4.14998 13.747 3.74703 14.15 3.24998 14.15H1.74998C1.25292 14.15 0.849976 13.747 0.849976 13.25V11.75C0.849976 11.2529 1.25292 10.85 1.74998 10.85H2.04998V4.14998H1.74998C1.25292 4.14998 0.849976 3.74703 0.849976 3.24998V1.74998ZM2.94998 4.14998V10.85H3.24998C3.74703 10.85 4.14998 11.2529 4.14998 11.75V12.05H10.85V11.75C10.85 11.2529 11.2529 10.85 11.75 10.85H12.05V4.14998H11.75C11.2529 4.14998 10.85 3.74703 10.85 3.24998V2.94998H4.14998V3.24998C4.14998 3.74703 3.74703 4.14998 3.24998 4.14998H2.94998ZM2.34998 1.74998H1.74998V2.34998V2.64998V3.24998H2.34998H2.64998H3.24998V2.64998V2.34998V1.74998H2.64998H2.34998ZM5.09998 5.99998C5.09998 5.50292 5.50292 5.09998 5.99998 5.09998H6.99998C7.49703 5.09998 7.89998 5.50292 7.89998 5.99998V6.99998C7.89998 7.03591 7.89787 7.07134 7.89378 7.10618C7.92861 7.10208 7.96405 7.09998 7.99998 7.09998H8.99998C9.49703 7.09998 9.89998 7.50292 9.89998 7.99998V8.99998C9.89998 9.49703 9.49703 9.89998 8.99998 9.89998H7.99998C7.50292 9.89998 7.09998 9.49703 7.09998 8.99998V7.99998C7.09998 7.96405 7.10208 7.92861 7.10618 7.89378C7.07134 7.89787 7.03591 7.89998 6.99998 7.89998H5.99998C5.50292 7.89998 5.09998 7.49703 5.09998 6.99998V5.99998ZM6.09998 5.99998H5.99998V6.09998V6.89998V6.99998H6.09998H6.89998H6.99998V6.89998V6.09998V5.99998H6.89998H6.09998ZM7.99998 7.99998H8.09998H8.89998H8.99998V8.09998V8.89998V8.99998H8.89998H8.09998H7.99998V8.89998V8.09998V7.99998ZM2.64998 11.75H2.34998H1.74998V12.35V12.65V13.25H2.34998H2.64998H3.24998V12.65V12.35V11.75H2.64998ZM11.75 1.74998H12.35H12.65H13.25V2.34998V2.64998V3.24998H12.65H12.35H11.75V2.64998V2.34998V1.74998ZM12.65 11.75H12.35H11.75V12.35V12.65V13.25H12.35H12.65H13.25V12.65V12.35V11.75H12.65Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Expert Instructors",
                desc: "Learn from experienced professionals with real-world development expertise."
            },
            {
                id: "2",
                icon: ( <svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M3.00014 2.73895C3.00014 2.94698 2.76087 3.06401 2.59666 2.93628L1.00386 1.69744C0.875177 1.59735 0.875177 1.40286 1.00386 1.30277L2.59666 0.063928C2.76087 -0.0637944 3.00014 0.0532293 3.00014 0.261266V1.00012H9.00009V0.261296C9.00009 0.0532591 9.23936 -0.0637646 9.40358 0.0639578L10.9964 1.3028C11.1251 1.40289 11.1251 1.59738 10.9964 1.69747L9.40358 2.93631C9.23936 3.06404 9.00009 2.94701 9.00009 2.73898V2.00012H3.00014V2.73895ZM9.50002 4.99998H2.50002C2.22388 4.99998 2.00002 5.22384 2.00002 5.49998V12.5C2.00002 12.7761 2.22388 13 2.50002 13H9.50002C9.77616 13 10 12.7761 10 12.5V5.49998C10 5.22384 9.77616 4.99998 9.50002 4.99998ZM2.50002 3.99998C1.67159 3.99998 1.00002 4.67156 1.00002 5.49998V12.5C1.00002 13.3284 1.67159 14 2.50002 14H9.50002C10.3284 14 11 13.3284 11 12.5V5.49998C11 4.67156 10.3284 3.99998 9.50002 3.99998H2.50002ZM14.7389 6.00001H14V12H14.7389C14.9469 12 15.064 12.2393 14.9362 12.4035L13.6974 13.9963C13.5973 14.125 13.4028 14.125 13.3027 13.9963L12.0639 12.4035C11.9362 12.2393 12.0532 12 12.2612 12H13V6.00001H12.2612C12.0532 6.00001 11.9361 5.76074 12.0639 5.59653L13.3027 4.00373C13.4028 3.87505 13.5973 3.87505 13.6974 4.00374L14.9362 5.59653C15.0639 5.76074 14.9469 6.00001 14.7389 6.00001Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Comprehensive Curriculum",
                desc: "Gain practical skills tailored to current industry demands."
            },
            {
                id: "3",
                icon: (<svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M1 2C0.447715 2 0 2.44772 0 3V12C0 12.5523 0.447715 13 1 13H14C14.5523 13 15 12.5523 15 12V3C15 2.44772 14.5523 2 14 2H1ZM1 3L14 3V3.92494C13.9174 3.92486 13.8338 3.94751 13.7589 3.99505L7.5 7.96703L1.24112 3.99505C1.16621 3.94751 1.0826 3.92486 1 3.92494V3ZM1 4.90797V12H14V4.90797L7.74112 8.87995C7.59394 8.97335 7.40606 8.97335 7.25888 8.87995L1 4.90797Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Career Support",
                desc: "Access job placement assistance, portfolio development guidance, and networking opportunities."
            },
            {
                id: "4",
                icon: ( <svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M4.5 2C3.11929 2 2 3.11929 2 4.5C2 5.88072 3.11929 7 4.5 7C5.88072 7 7 5.88072 7 4.5C7 3.11929 5.88072 2 4.5 2ZM3 4.5C3 3.67157 3.67157 3 4.5 3C5.32843 3 6 3.67157 6 4.5C6 5.32843 5.32843 6 4.5 6C3.67157 6 3 5.32843 3 4.5ZM10.5 2C9.11929 2 8 3.11929 8 4.5C8 5.88072 9.11929 7 10.5 7C11.8807 7 13 5.88072 13 4.5C13 3.11929 11.8807 2 10.5 2ZM9 4.5C9 3.67157 9.67157 3 10.5 3C11.3284 3 12 3.67157 12 4.5C12 5.32843 11.3284 6 10.5 6C9.67157 6 9 5.32843 9 4.5ZM2 10.5C2 9.11929 3.11929 8 4.5 8C5.88072 8 7 9.11929 7 10.5C7 11.8807 5.88072 13 4.5 13C3.11929 13 2 11.8807 2 10.5ZM4.5 9C3.67157 9 3 9.67157 3 10.5C3 11.3284 3.67157 12 4.5 12C5.32843 12 6 11.3284 6 10.5C6 9.67157 5.32843 9 4.5 9ZM10.5 8C9.11929 8 8 9.11929 8 10.5C8 11.8807 9.11929 13 10.5 13C11.8807 13 13 11.8807 13 10.5C13 9.11929 11.8807 8 10.5 8ZM9 10.5C9 9.67157 9.67157 9 10.5 9C11.3284 9 12 9.67157 12 10.5C12 11.3284 11.3284 12 10.5 12C9.67157 12 9 11.3284 9 10.5Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Cutting-edge Technologies",
                desc: "Stay ahead with the latest tools and frameworks through hands-on projects and workshops."
            },
            {
                id: "5",
                icon: (<svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M9.96424 2.68571C10.0668 2.42931 9.94209 2.13833 9.6857 2.03577C9.4293 1.93322 9.13832 2.05792 9.03576 2.31432L5.03576 12.3143C4.9332 12.5707 5.05791 12.8617 5.3143 12.9642C5.5707 13.0668 5.86168 12.9421 5.96424 12.6857L9.96424 2.68571ZM3.85355 5.14646C4.04882 5.34172 4.04882 5.6583 3.85355 5.85356L2.20711 7.50001L3.85355 9.14646C4.04882 9.34172 4.04882 9.6583 3.85355 9.85356C3.65829 10.0488 3.34171 10.0488 3.14645 9.85356L1.14645 7.85356C0.951184 7.6583 0.951184 7.34172 1.14645 7.14646L3.14645 5.14646C3.34171 4.9512 3.65829 4.9512 3.85355 5.14646ZM11.1464 5.14646C11.3417 4.9512 11.6583 4.9512 11.8536 5.14646L13.8536 7.14646C14.0488 7.34172 14.0488 7.6583 13.8536 7.85356L11.8536 9.85356C11.6583 10.0488 11.3417 10.0488 11.1464 9.85356C10.9512 9.6583 10.9512 9.34172 11.1464 9.14646L12.7929 7.50001L11.1464 5.85356C10.9512 5.6583 10.9512 5.34172 11.1464 5.14646Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Community Engagement",
                desc: "Connect with a vibrant community of learners and industry experts for collaborative growth."
            },
            {
                id: "6",
                icon: ( <svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M7.28856 0.796908C7.42258 0.734364 7.57742 0.734364 7.71144 0.796908L13.7114 3.59691C13.8875 3.67906 14 3.85574 14 4.05V10.95C14 11.1443 13.8875 11.3209 13.7114 11.4031L7.71144 14.2031C7.57742 14.2656 7.42258 14.2656 7.28856 14.2031L1.28856 11.4031C1.11252 11.3209 1 11.1443 1 10.95V4.05C1 3.85574 1.11252 3.67906 1.28856 3.59691L7.28856 0.796908ZM2 4.80578L7 6.93078V12.9649L2 10.6316V4.80578ZM8 12.9649L13 10.6316V4.80578L8 6.93078V12.9649ZM7.5 6.05672L12.2719 4.02866L7.5 1.80176L2.72809 4.02866L7.5 6.05672Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "State-of-the-art Facilities",
                desc: "Benefit from our dedicated on-site computer labs and interactive learning environment."
            },
        ]
       
    },
    {
        id: "4",
        title: "What You'll Learn",
        sub_title:"Master essential full-stack development skills and tools to create robust, scalable applications that meet modern business needs.",
        Course_img: [
            {
                id: "1",
                img: "https://jbstechinfo.com/wp-content/uploads/2023/08/JavaScript-Symbol.png",
                title: "JavaScript",
                alt: "JavaScript",
            },
            {
                id: "2",
                img: "https://upload.wikimedia.org/wikipedia/commons/d/d9/Node.js_logo.svg",
                title: "Node.js",
                alt: "Node.js",
            },
            {
                id: "4",
                img: "https://miro.medium.com/v2/resize:fit:860/0*eFomJUFua8tuqe8g.png",
                title: "jQuery",
                alt: "jQuery",
            },
        ]
    },
    {
        id: "5",
        title: "Frequently Asked Questions (FAQs)",
        sub_title: "Still have questions about our Full-Stack Development course? We've got you covered. Check out these commonly asked questions to find the answers you need.",
        faqs: [
           {
            id: "1",
            heading: " Who is this course for?",
            sub_heading: "This course is designed for individuals with basic programming knowledge, as well as those looking to transition into full-stack development from other IT fields.",
           },
           {
            id: "2",
            heading: "Do I need any special software or equipment?",
            sub_heading: "You'll need a computer with internet access. We recommend a system with at least 8GB RAM and a modern processor. Most software we use is open-source, but we'll provide a detailed list upon enrollment.",
           },
           {
            id: "3",
            heading: "How long does the course take to complete?",
            sub_heading: "The course is designed to be completed in approximately 12 months, but you can learn at your own pace. You'll have lifetime access to the course materials.",
           },
           {
            id: "4",
            heading: "Is there a certificate upon completion?",
            sub_heading: "Yes, you'll receive a certificate of completion that you can add to your resume or LinkedIn profile.",
           },
           {
            id: "5",
            heading: "What if I have questions during the course?",
            sub_heading: "We offer weekly live Q&A sessions, a community forum, and email support to address any questions you may have.",
           },
        ]
    }
]


export const Graphic = [
    {
        id: "1",
        small_text: "Start your career as a Graphic Designing",
        name: "Graphic Designing course in kurukshetra",
        duration_One : "6 Months ",
        description: "In today's world where visuals are key, there's a rising need for creative experts who can effectively communicate through design. At BrainboxStudy, we provide thorough training in graphic design. Our goal is to foster your creativity and equip you with the technical skills necessary to succeed in this dynamic and thrilling field. Join us to forge a vibrant career in visual communication!",
        image: "/Graphicdesigning.png",
        alt: "Graphic Designing",
        join_btn: "Join Now",
    },
    {
        id: "2",
        main_image: "https://img.freepik.com/free-vector/tiny-graphic-designer-drawing-with-big-pen-computer-screen-creators-work-creative-woman-working-laptop-flat-vector-illustration-digital-design-concept-banner-landing-web-page_74855-25342.jpg?t=st=1720781836~exp=1720785436~hmac=41b4c59493097ef52c4d532f83a8a691abb407bc22e9e745f870aedf358c883f&w=740",
        small_text_one: "Graphic Design Course",
        title: "Graphic Design Course in Kurukshetra: Why Choose This Career?",
        desc: "In today's digital world, graphic design is crucial for marketing, branding, and communication strategies. Businesses in every industry need skilled designers to create visually appealing and effective content. This career combines creativity with technical know-how, letting you express ideas and solve problems visually. Our Graphic Design Course in Kurukshetra is perfect for those passionate about art and technology.Whether you're a creative person starting a new career or a professional improving your visual communication skills, graphic design offers many advantages. It opens doors to freelance and full-time roles, fosters ongoing creative development, and allows you to work across diverse fields. As businesses realize the impact of visual branding, graphic designers play a vital role in shaping how products and companies are perceived.",
        visit_btn: " Visit the help center",
        alt: "Graphic Designing",
    },
    {
        id: "3",
        title: "Why Choose BrainboxStudy for Graphic Design?",
        sub_title: "Start your path to becoming a skilled graphic designer with our courses tailored to industry needs.",
        feature: [
            {
                id: "1",
                icon: ( <svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M0.849976 1.74998C0.849976 1.25292 1.25292 0.849976 1.74998 0.849976H3.24998C3.74703 0.849976 4.14998 1.25292 4.14998 1.74998V2.04998H10.85V1.74998C10.85 1.25292 11.2529 0.849976 11.75 0.849976H13.25C13.747 0.849976 14.15 1.25292 14.15 1.74998V3.24998C14.15 3.74703 13.747 4.14998 13.25 4.14998H12.95V10.85H13.25C13.747 10.85 14.15 11.2529 14.15 11.75V13.25C14.15 13.747 13.747 14.15 13.25 14.15H11.75C11.2529 14.15 10.85 13.747 10.85 13.25V12.95H4.14998V13.25C4.14998 13.747 3.74703 14.15 3.24998 14.15H1.74998C1.25292 14.15 0.849976 13.747 0.849976 13.25V11.75C0.849976 11.2529 1.25292 10.85 1.74998 10.85H2.04998V4.14998H1.74998C1.25292 4.14998 0.849976 3.74703 0.849976 3.24998V1.74998ZM2.94998 4.14998V10.85H3.24998C3.74703 10.85 4.14998 11.2529 4.14998 11.75V12.05H10.85V11.75C10.85 11.2529 11.2529 10.85 11.75 10.85H12.05V4.14998H11.75C11.2529 4.14998 10.85 3.74703 10.85 3.24998V2.94998H4.14998V3.24998C4.14998 3.74703 3.74703 4.14998 3.24998 4.14998H2.94998ZM2.34998 1.74998H1.74998V2.34998V2.64998V3.24998H2.34998H2.64998H3.24998V2.64998V2.34998V1.74998H2.64998H2.34998ZM5.09998 5.99998C5.09998 5.50292 5.50292 5.09998 5.99998 5.09998H6.99998C7.49703 5.09998 7.89998 5.50292 7.89998 5.99998V6.99998C7.89998 7.03591 7.89787 7.07134 7.89378 7.10618C7.92861 7.10208 7.96405 7.09998 7.99998 7.09998H8.99998C9.49703 7.09998 9.89998 7.50292 9.89998 7.99998V8.99998C9.89998 9.49703 9.49703 9.89998 8.99998 9.89998H7.99998C7.50292 9.89998 7.09998 9.49703 7.09998 8.99998V7.99998C7.09998 7.96405 7.10208 7.92861 7.10618 7.89378C7.07134 7.89787 7.03591 7.89998 6.99998 7.89998H5.99998C5.50292 7.89998 5.09998 7.49703 5.09998 6.99998V5.99998ZM6.09998 5.99998H5.99998V6.09998V6.89998V6.99998H6.09998H6.89998H6.99998V6.89998V6.09998V5.99998H6.89998H6.09998ZM7.99998 7.99998H8.09998H8.89998H8.99998V8.09998V8.89998V8.99998H8.89998H8.09998H7.99998V8.89998V8.09998V7.99998ZM2.64998 11.75H2.34998H1.74998V12.35V12.65V13.25H2.34998H2.64998H3.24998V12.65V12.35V11.75H2.64998ZM11.75 1.74998H12.35H12.65H13.25V2.34998V2.64998V3.24998H12.65H12.35H11.75V2.64998V2.34998V1.74998ZM12.65 11.75H12.35H11.75V12.35V12.65V13.25H12.35H12.65H13.25V12.65V12.35V11.75H12.65Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Experienced Mentors",
                desc: " Learn from seasoned designers with diverse industry experience."
            },
            {
                id: "2",
                icon: ( <svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M3.00014 2.73895C3.00014 2.94698 2.76087 3.06401 2.59666 2.93628L1.00386 1.69744C0.875177 1.59735 0.875177 1.40286 1.00386 1.30277L2.59666 0.063928C2.76087 -0.0637944 3.00014 0.0532293 3.00014 0.261266V1.00012H9.00009V0.261296C9.00009 0.0532591 9.23936 -0.0637646 9.40358 0.0639578L10.9964 1.3028C11.1251 1.40289 11.1251 1.59738 10.9964 1.69747L9.40358 2.93631C9.23936 3.06404 9.00009 2.94701 9.00009 2.73898V2.00012H3.00014V2.73895ZM9.50002 4.99998H2.50002C2.22388 4.99998 2.00002 5.22384 2.00002 5.49998V12.5C2.00002 12.7761 2.22388 13 2.50002 13H9.50002C9.77616 13 10 12.7761 10 12.5V5.49998C10 5.22384 9.77616 4.99998 9.50002 4.99998ZM2.50002 3.99998C1.67159 3.99998 1.00002 4.67156 1.00002 5.49998V12.5C1.00002 13.3284 1.67159 14 2.50002 14H9.50002C10.3284 14 11 13.3284 11 12.5V5.49998C11 4.67156 10.3284 3.99998 9.50002 3.99998H2.50002ZM14.7389 6.00001H14V12H14.7389C14.9469 12 15.064 12.2393 14.9362 12.4035L13.6974 13.9963C13.5973 14.125 13.4028 14.125 13.3027 13.9963L12.0639 12.4035C11.9362 12.2393 12.0532 12 12.2612 12H13V6.00001H12.2612C12.0532 6.00001 11.9361 5.76074 12.0639 5.59653L13.3027 4.00373C13.4028 3.87505 13.5973 3.87505 13.6974 4.00374L14.9362 5.59653C15.0639 5.76074 14.9469 6.00001 14.7389 6.00001Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Practical Training",
                desc: "Gain hands-on skills that meet current industry requirements."
            },
            {
                id: "3",
                icon: (<svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M1 2C0.447715 2 0 2.44772 0 3V12C0 12.5523 0.447715 13 1 13H14C14.5523 13 15 12.5523 15 12V3C15 2.44772 14.5523 2 14 2H1ZM1 3L14 3V3.92494C13.9174 3.92486 13.8338 3.94751 13.7589 3.99505L7.5 7.96703L1.24112 3.99505C1.16621 3.94751 1.0826 3.92486 1 3.92494V3ZM1 4.90797V12H14V4.90797L7.74112 8.87995C7.59394 8.97335 7.40606 8.97335 7.25888 8.87995L1 4.90797Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Career Assistance",
                desc: "Get help with portfolio development, job placement, and networking."
            },
            {
                id: "4",
                icon: ( <svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M4.5 2C3.11929 2 2 3.11929 2 4.5C2 5.88072 3.11929 7 4.5 7C5.88072 7 7 5.88072 7 4.5C7 3.11929 5.88072 2 4.5 2ZM3 4.5C3 3.67157 3.67157 3 4.5 3C5.32843 3 6 3.67157 6 4.5C6 5.32843 5.32843 6 4.5 6C3.67157 6 3 5.32843 3 4.5ZM10.5 2C9.11929 2 8 3.11929 8 4.5C8 5.88072 9.11929 7 10.5 7C11.8807 7 13 5.88072 13 4.5C13 3.11929 11.8807 2 10.5 2ZM9 4.5C9 3.67157 9.67157 3 10.5 3C11.3284 3 12 3.67157 12 4.5C12 5.32843 11.3284 6 10.5 6C9.67157 6 9 5.32843 9 4.5ZM2 10.5C2 9.11929 3.11929 8 4.5 8C5.88072 8 7 9.11929 7 10.5C7 11.8807 5.88072 13 4.5 13C3.11929 13 2 11.8807 2 10.5ZM4.5 9C3.67157 9 3 9.67157 3 10.5C3 11.3284 3.67157 12 4.5 12C5.32843 12 6 11.3284 6 10.5C6 9.67157 5.32843 9 4.5 9ZM10.5 8C9.11929 8 8 9.11929 8 10.5C8 11.8807 9.11929 13 10.5 13C11.8807 13 13 11.8807 13 10.5C13 9.11929 11.8807 8 10.5 8ZM9 10.5C9 9.67157 9.67157 9 10.5 9C11.3284 9 12 9.67157 12 10.5C12 11.3284 11.3284 12 10.5 12C9.67157 12 9 11.3284 9 10.5Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Latest Tools",
                desc: "Master industry-standard design software and tools used by professionals."
            },
            {
                id: "5",
                icon: (<svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M9.96424 2.68571C10.0668 2.42931 9.94209 2.13833 9.6857 2.03577C9.4293 1.93322 9.13832 2.05792 9.03576 2.31432L5.03576 12.3143C4.9332 12.5707 5.05791 12.8617 5.3143 12.9642C5.5707 13.0668 5.86168 12.9421 5.96424 12.6857L9.96424 2.68571ZM3.85355 5.14646C4.04882 5.34172 4.04882 5.6583 3.85355 5.85356L2.20711 7.50001L3.85355 9.14646C4.04882 9.34172 4.04882 9.6583 3.85355 9.85356C3.65829 10.0488 3.34171 10.0488 3.14645 9.85356L1.14645 7.85356C0.951184 7.6583 0.951184 7.34172 1.14645 7.14646L3.14645 5.14646C3.34171 4.9512 3.65829 4.9512 3.85355 5.14646ZM11.1464 5.14646C11.3417 4.9512 11.6583 4.9512 11.8536 5.14646L13.8536 7.14646C14.0488 7.34172 14.0488 7.6583 13.8536 7.85356L11.8536 9.85356C11.6583 10.0488 11.3417 10.0488 11.1464 9.85356C10.9512 9.6583 10.9512 9.34172 11.1464 9.14646L12.7929 7.50001L11.1464 5.85356C10.9512 5.6583 10.9512 5.34172 11.1464 5.14646Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Community",
                desc: " Connect with fellow designers and industry experts for collaborative learning."
            },
            {
                id: "6",
                icon: ( <svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M7.28856 0.796908C7.42258 0.734364 7.57742 0.734364 7.71144 0.796908L13.7114 3.59691C13.8875 3.67906 14 3.85574 14 4.05V10.95C14 11.1443 13.8875 11.3209 13.7114 11.4031L7.71144 14.2031C7.57742 14.2656 7.42258 14.2656 7.28856 14.2031L1.28856 11.4031C1.11252 11.3209 1 11.1443 1 10.95V4.05C1 3.85574 1.11252 3.67906 1.28856 3.59691L7.28856 0.796908ZM2 4.80578L7 6.93078V12.9649L2 10.6316V4.80578ZM8 12.9649L13 10.6316V4.80578L8 6.93078V12.9649ZM7.5 6.05672L12.2719 4.02866L7.5 1.80176L2.72809 4.02866L7.5 6.05672Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "State-of-the-art Facilities",
                desc: " Use our well-equipped design studios with high-performance computers and specialized equipment."
            },
        ]
       
    },
    {
        id: "4",
        title: "What You'll Learn",
        sub_title:"You'll develop key graphic design skills such as typography, color theory, layout design, branding, digital illustration, and proficiency in industry-standard software like Adobe Creative Suite.",
        Course_img: [
            {
                id: "1",
                img: "https://img.freepik.com/free-photo/close-up-shot-video-graphic-editor-using-specialized-software-edit-movie-footage-improve-visual-quality-professional-videographer-sitting-multi-monitor-workstation-enhancing-film-frames_482257-43894.jpg?t=st=1720781917~exp=1720785517~hmac=81511424dc55688702376d38724a5fae03e88a053eb941919d5e0e51586d7629&w=360",
                title: "PhotoShop",
                alt: "PhotoShop"
            },
            {
                id: "2",
                img: "https://spin.atomicobject.com/wp-content/uploads/Figma-Image.jpg",
                title: "Adobe premiere pro",
                alt: "Adobe premiere pro"
            },
            {
                id: "4",
                img: "https://cdn.sanity.io/images/599r6htc/regionalized/93df3f9bf6d10a5bb177f6cfeda85787ae83aef2-2400x1260.png?w=1200&q=70&fit=max&auto=format",
                title: "Figma",
                alt: "Figma"
            },
        ]
    },
    {
        id: "5",
        title: "Frequently Asked Questions (FAQs)",
        sub_title: "StStill have questions about our Graphic Design course? Here are answers to common queries",
        faqs: [
           {
            id: "1",
            heading: "Who should take this course?",
            sub_heading: "This course is for creative individuals passionate about visual arts and those switching to graphic design from other fields.",
           },
           {
            id: "2",
            heading: "Do I need drawing skills to be a graphic designer?",
            sub_heading: "While drawing can help, it's not required. We focus on digital design tools and principles that don't rely on traditional artistic skills.",
           },
           {
            id: "3",
            heading: "What software will I learn?",
            sub_heading: "You'll master industry-standard tools like Adobe Photoshop, Illustrator, and InDesign. We also cover other relevant tools as per current industry trends.",
           },
           {
            id: "4",
            heading: "Is there a final project or portfolio development?",
            sub_heading: "Yes, you'll work on various projects throughout the course and build a professional portfolio showcasing your skills by the end.",
           },
           {
            id: "5",
            heading: "Are there internship or real-world project opportunities?",
            sub_heading: "We collaborate with local businesses for real-world project experience. We also help interested students find internship opportunities.",
           },
        ]
    }
]


export const DataScience = [
    {
        id: "1",
        small_text: "Start your career as a Data Science",
        name: "Data Science course in kurukshetra",
        duration_One : "6 Months",
        description: "In today's world driven by data, there's a growing need for experts who can uncover valuable insights from complex data. At BrainboxStudy, we provide thorough training in data science. Our aim is to prepare you with the skills necessary to succeed in this fast-growing and influential field. Join us to forge a career at the forefront of data analytics and machine learning!",
        image: "/data.png",
        alt: 'Data Science',
        join_btn: "Join Now",
    },
    {
        id: "2",
        main_image: "https://img.freepik.com/free-photo/office-workers-using-finance-graphs_23-2150408661.jpg?t=st=1720780420~exp=1720784020~hmac=7ba371ed992fec42091dc7facd43296ac49f3978cdf69d027b5b265848ecd9b2&w=740",
        small_text_one: "Data Science Course",
        alt: "Data Science",
        title: "Data Science Course In Kurukshetra: Why Choose This Career?",
        desc: "In the age of big data, data science is essential in every industry. Organizations increasingly rely on data-driven insights to make strategic decisions, improve operations, and predict future trends. This career blends analytical thinking with statistical knowledge, empowering you to tackle complex challenges and uncover patterns in data. Our Data Science Course in Kurukshetra is ideal for those passionate about using data to drive innovation.Whether you're a recent graduate or a professional looking to switch careers, data science offers many benefits. It includes high-paying job opportunities, continuous learning in a rapidly changing field, and the flexibility to work across different sectors. As companies value data-driven decision-making more, data scientists play a crucial role in shaping business strategies and technological advancements.",
        visit_btn: " Visit the help center"
    },
    {
        id: "3",
        title: "Why Choose BrainboxStudy for Data Science?",
        sub_title: "Start your path to becoming a proficient data scientist with our courses tailored to industry needs.",
        feature: [
            {
                id: "1",
                icon: ( <svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M0.849976 1.74998C0.849976 1.25292 1.25292 0.849976 1.74998 0.849976H3.24998C3.74703 0.849976 4.14998 1.25292 4.14998 1.74998V2.04998H10.85V1.74998C10.85 1.25292 11.2529 0.849976 11.75 0.849976H13.25C13.747 0.849976 14.15 1.25292 14.15 1.74998V3.24998C14.15 3.74703 13.747 4.14998 13.25 4.14998H12.95V10.85H13.25C13.747 10.85 14.15 11.2529 14.15 11.75V13.25C14.15 13.747 13.747 14.15 13.25 14.15H11.75C11.2529 14.15 10.85 13.747 10.85 13.25V12.95H4.14998V13.25C4.14998 13.747 3.74703 14.15 3.24998 14.15H1.74998C1.25292 14.15 0.849976 13.747 0.849976 13.25V11.75C0.849976 11.2529 1.25292 10.85 1.74998 10.85H2.04998V4.14998H1.74998C1.25292 4.14998 0.849976 3.74703 0.849976 3.24998V1.74998ZM2.94998 4.14998V10.85H3.24998C3.74703 10.85 4.14998 11.2529 4.14998 11.75V12.05H10.85V11.75C10.85 11.2529 11.2529 10.85 11.75 10.85H12.05V4.14998H11.75C11.2529 4.14998 10.85 3.74703 10.85 3.24998V2.94998H4.14998V3.24998C4.14998 3.74703 3.74703 4.14998 3.24998 4.14998H2.94998ZM2.34998 1.74998H1.74998V2.34998V2.64998V3.24998H2.34998H2.64998H3.24998V2.64998V2.34998V1.74998H2.64998H2.34998ZM5.09998 5.99998C5.09998 5.50292 5.50292 5.09998 5.99998 5.09998H6.99998C7.49703 5.09998 7.89998 5.50292 7.89998 5.99998V6.99998C7.89998 7.03591 7.89787 7.07134 7.89378 7.10618C7.92861 7.10208 7.96405 7.09998 7.99998 7.09998H8.99998C9.49703 7.09998 9.89998 7.50292 9.89998 7.99998V8.99998C9.89998 9.49703 9.49703 9.89998 8.99998 9.89998H7.99998C7.50292 9.89998 7.09998 9.49703 7.09998 8.99998V7.99998C7.09998 7.96405 7.10208 7.92861 7.10618 7.89378C7.07134 7.89787 7.03591 7.89998 6.99998 7.89998H5.99998C5.50292 7.89998 5.09998 7.49703 5.09998 6.99998V5.99998ZM6.09998 5.99998H5.99998V6.09998V6.89998V6.99998H6.09998H6.89998H6.99998V6.89998V6.09998V5.99998H6.89998H6.09998ZM7.99998 7.99998H8.09998H8.89998H8.99998V8.09998V8.89998V8.99998H8.89998H8.09998H7.99998V8.89998V8.09998V7.99998ZM2.64998 11.75H2.34998H1.74998V12.35V12.65V13.25H2.34998H2.64998H3.24998V12.65V12.35V11.75H2.64998ZM11.75 1.74998H12.35H12.65H13.25V2.34998V2.64998V3.24998H12.65H12.35H11.75V2.64998V2.34998V1.74998ZM12.65 11.75H12.35H11.75V12.35V12.65V13.25H12.35H12.65H13.25V12.65V12.35V11.75H12.65Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Experienced Faculty",
                desc: "Learn from seasoned data scientists with vast industry knowledge."
            },
            {
                id: "2",
                icon: ( <svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M3.00014 2.73895C3.00014 2.94698 2.76087 3.06401 2.59666 2.93628L1.00386 1.69744C0.875177 1.59735 0.875177 1.40286 1.00386 1.30277L2.59666 0.063928C2.76087 -0.0637944 3.00014 0.0532293 3.00014 0.261266V1.00012H9.00009V0.261296C9.00009 0.0532591 9.23936 -0.0637646 9.40358 0.0639578L10.9964 1.3028C11.1251 1.40289 11.1251 1.59738 10.9964 1.69747L9.40358 2.93631C9.23936 3.06404 9.00009 2.94701 9.00009 2.73898V2.00012H3.00014V2.73895ZM9.50002 4.99998H2.50002C2.22388 4.99998 2.00002 5.22384 2.00002 5.49998V12.5C2.00002 12.7761 2.22388 13 2.50002 13H9.50002C9.77616 13 10 12.7761 10 12.5V5.49998C10 5.22384 9.77616 4.99998 9.50002 4.99998ZM2.50002 3.99998C1.67159 3.99998 1.00002 4.67156 1.00002 5.49998V12.5C1.00002 13.3284 1.67159 14 2.50002 14H9.50002C10.3284 14 11 13.3284 11 12.5V5.49998C11 4.67156 10.3284 3.99998 9.50002 3.99998H2.50002ZM14.7389 6.00001H14V12H14.7389C14.9469 12 15.064 12.2393 14.9362 12.4035L13.6974 13.9963C13.5973 14.125 13.4028 14.125 13.3027 13.9963L12.0639 12.4035C11.9362 12.2393 12.0532 12 12.2612 12H13V6.00001H12.2612C12.0532 6.00001 11.9361 5.76074 12.0639 5.59653L13.3027 4.00373C13.4028 3.87505 13.5973 3.87505 13.6974 4.00374L14.9362 5.59653C15.0639 5.76074 14.9469 6.00001 14.7389 6.00001Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Practical Curriculum",
                desc: "Gain hands-on skills that align with current market requirements."
            },
            {
                id: "3",
                icon: (<svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M1 2C0.447715 2 0 2.44772 0 3V12C0 12.5523 0.447715 13 1 13H14C14.5523 13 15 12.5523 15 12V3C15 2.44772 14.5523 2 14 2H1ZM1 3L14 3V3.92494C13.9174 3.92486 13.8338 3.94751 13.7589 3.99505L7.5 7.96703L1.24112 3.99505C1.16621 3.94751 1.0826 3.92486 1 3.92494V3ZM1 4.90797V12H14V4.90797L7.74112 8.87995C7.59394 8.97335 7.40606 8.97335 7.25888 8.87995L1 4.90797Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Career Support",
                desc: "Receive help with resume building, interview prep, and job placement."
            },
            {
                id: "4",
                icon: ( <svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M4.5 2C3.11929 2 2 3.11929 2 4.5C2 5.88072 3.11929 7 4.5 7C5.88072 7 7 5.88072 7 4.5C7 3.11929 5.88072 2 4.5 2ZM3 4.5C3 3.67157 3.67157 3 4.5 3C5.32843 3 6 3.67157 6 4.5C6 5.32843 5.32843 6 4.5 6C3.67157 6 3 5.32843 3 4.5ZM10.5 2C9.11929 2 8 3.11929 8 4.5C8 5.88072 9.11929 7 10.5 7C11.8807 7 13 5.88072 13 4.5C13 3.11929 11.8807 2 10.5 2ZM9 4.5C9 3.67157 9.67157 3 10.5 3C11.3284 3 12 3.67157 12 4.5C12 5.32843 11.3284 6 10.5 6C9.67157 6 9 5.32843 9 4.5ZM2 10.5C2 9.11929 3.11929 8 4.5 8C5.88072 8 7 9.11929 7 10.5C7 11.8807 5.88072 13 4.5 13C3.11929 13 2 11.8807 2 10.5ZM4.5 9C3.67157 9 3 9.67157 3 10.5C3 11.3284 3.67157 12 4.5 12C5.32843 12 6 11.3284 6 10.5C6 9.67157 5.32843 9 4.5 9ZM10.5 8C9.11929 8 8 9.11929 8 10.5C8 11.8807 9.11929 13 10.5 13C11.8807 13 13 11.8807 13 10.5C13 9.11929 11.8807 8 10.5 8ZM9 10.5C9 9.67157 9.67157 9 10.5 9C11.3284 9 12 9.67157 12 10.5C12 11.3284 11.3284 12 10.5 12C9.67157 12 9 11.3284 9 10.5Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Cutting-edge Tools",
                desc: "Stay updated with the latest data analysis tools, machine learning algorithms, and visualization techniques."
            },
            {
                id: "5",
                icon: (<svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M9.96424 2.68571C10.0668 2.42931 9.94209 2.13833 9.6857 2.03577C9.4293 1.93322 9.13832 2.05792 9.03576 2.31432L5.03576 12.3143C4.9332 12.5707 5.05791 12.8617 5.3143 12.9642C5.5707 13.0668 5.86168 12.9421 5.96424 12.6857L9.96424 2.68571ZM3.85355 5.14646C4.04882 5.34172 4.04882 5.6583 3.85355 5.85356L2.20711 7.50001L3.85355 9.14646C4.04882 9.34172 4.04882 9.6583 3.85355 9.85356C3.65829 10.0488 3.34171 10.0488 3.14645 9.85356L1.14645 7.85356C0.951184 7.6583 0.951184 7.34172 1.14645 7.14646L3.14645 5.14646C3.34171 4.9512 3.65829 4.9512 3.85355 5.14646ZM11.1464 5.14646C11.3417 4.9512 11.6583 4.9512 11.8536 5.14646L13.8536 7.14646C14.0488 7.34172 14.0488 7.6583 13.8536 7.85356L11.8536 9.85356C11.6583 10.0488 11.3417 10.0488 11.1464 9.85356C10.9512 9.6583 10.9512 9.34172 11.1464 9.14646L12.7929 7.50001L11.1464 5.85356C10.9512 5.6583 10.9512 5.34172 11.1464 5.14646Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Networking",
                desc: "Connect with a diverse community of learners and industry experts."
            },
            {
                id: "6",
                icon: ( <svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M7.28856 0.796908C7.42258 0.734364 7.57742 0.734364 7.71144 0.796908L13.7114 3.59691C13.8875 3.67906 14 3.85574 14 4.05V10.95C14 11.1443 13.8875 11.3209 13.7114 11.4031L7.71144 14.2031C7.57742 14.2656 7.42258 14.2656 7.28856 14.2031L1.28856 11.4031C1.11252 11.3209 1 11.1443 1 10.95V4.05C1 3.85574 1.11252 3.67906 1.28856 3.59691L7.28856 0.796908ZM2 4.80578L7 6.93078V12.9649L2 10.6316V4.80578ZM8 12.9649L13 10.6316V4.80578L8 6.93078V12.9649ZM7.5 6.05672L12.2719 4.02866L7.5 1.80176L2.72809 4.02866L7.5 6.05672Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "State-of-the-art Facilities",
                desc: "Use our well-equipped data labs and high-performance computing resources."
            },
        ]
       
    },
    {
        id: "4",
        title: "What You'll Learn",
        sub_title:"You'll gain crucial data science skills like analyzing statistics, using machine learning, visualizing data, and working with big data technologies to solve practical problems.",
        Course_img: [
            {
                id: "1",
                img: "https://img.freepik.com/free-vector/hand-drawn-flat-design-website-hosting-illustration_23-2149231429.jpg?t=st=1720782353~exp=1720785953~hmac=13f7321b3b95890e32442431a0e65e96adc196f92c7a2293ffb073e57f140a23&w=740",
                title: "Data Mining",
                alt: "Data Mining"
            },
            {
                id: "2",
                img: "https://img.freepik.com/free-photo/team-cybercriminals-fixing-computer-system-cyberattack_482257-90449.jpg?t=st=1720782393~exp=1720785993~hmac=142f5676ac9cdf16f0a85b962a349330762fa8cb8a6c30496b6731a3ef518414&w=740",
                title: "Database",
                alt: "Database"
            },
            {
                id: "4",
                img: "https://img.freepik.com/free-vector/abstract-technology-sql-illustration_23-2149238125.jpg?t=st=1720782445~exp=1720786045~hmac=8e77f8bf87b59f7e0bff59b6377f805b5bbf7a67a5dcc1abf03706bfeb9aa75b&w=740",
                title: "SQL",
                // alt: "SQL"
            },
        ]
    },
    {
        id: "5",
        title: "Frequently Asked Questions (FAQs)",
        sub_title: "Still have questions about our Data Science course? Here are some common queries answered to assist you",
        faqs: [
           {
            id: "1",
            heading: "Who should take this course?",
            sub_heading: "This course is perfect for individuals with backgrounds in math, stats, computer science, or related fields, and professionals aiming to shift into data science.",
           },
           {
            id: "2",
            heading: " What are the prerequisites?",
            sub_heading: "Basic programming skills (especially Python) and a solid understanding of math and stats are recommended. We also offer preparatory modules for those needing to brush up on these skills.",
           },
           {
            id: "3",
            heading: "How is the course structured?",
            sub_heading: "The course is divided into modules covering statistics, programming, machine learning, data visualization, and big data technologies. It includes lectures, hands-on projects, and a capstone project.",
           },
           {
            id: "4",
            heading: " Will I get help finding a job?",
            sub_heading: "Yes, we provide career services such as resume reviews, mock interviews, and connections with industry partners for potential job opportunities.",
           },
           {
            id: "5",
            heading: "Can I take this course while working full-time?",
            sub_heading: "Absolutely! Our course is designed with flexibility in mind for working professionals. We offer various scheduling options and provide recorded lectures for review.",
           },
        ]
    }
]


export const UiUx = [
  {
      id: "1",
      small_text: "Start your career as a UI/UX",
      name: "UI/UX Design Course In Kurukshetra",
      duration_One : "6 Months",
      description: "In the digital age, user experience is crucial. There's a growing demand for designers who can create easy-to-use and attractive interfaces. At BrainboxStudy, we provide thorough training in UI/UX design. Our goal is to give you the skills needed to succeed in this creative and important field. Join us and help shape the future of digital interactions!",
      image: "/Uiux.png",
      alt: "UI/UX",
      join_btn: "Join Now",
  },
  {
      id: "2",
      main_image: "https://cdn-llngb.nitrocdn.com/llFNHfgcDPRANqvXFlKlalFtYgdhejba/assets/images/optimized/rev-b0b5cce/www.itrobes.com/wp-content/uploads/2024/01/UIUX-design-cost.jpg",
      small_text_one: "UI/UX Course",
      alt: 'UI/UX',
      title: "UI/UX Design Course in Kurukshetra: Why Choose This Career?",
      desc: "In today's digital world, UI/UX design is vital for product development. Companies need designers who can create smooth, engaging user experiences on various platforms. This career combines creativity with psychology, impacting how users interact with digital products. Our UI/UX Design Course in Kurukshetra is perfect for those who love design and user-centered thinking. Whether you're a recent graduate or a professional looking to change careers, UI/UX design offers exciting opportunities. It allows you to work on diverse projects, grow creatively, and make a real difference in users' lives. As businesses see the value of good user experience, UI/UX designers are essential for shaping product strategies and ensuring user satisfaction.",
      visit_btn: " Visit the help center"
  },
  {
      id: "3",
      title: "Why Choose BrainboxStudy for UI/UX Design?",
      sub_title: "Start your journey to becoming a skilled UI/UX designer with our practical and relevant courses.",
      feature: [
          {
              id: "1",
              icon: ( <svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M0.849976 1.74998C0.849976 1.25292 1.25292 0.849976 1.74998 0.849976H3.24998C3.74703 0.849976 4.14998 1.25292 4.14998 1.74998V2.04998H10.85V1.74998C10.85 1.25292 11.2529 0.849976 11.75 0.849976H13.25C13.747 0.849976 14.15 1.25292 14.15 1.74998V3.24998C14.15 3.74703 13.747 4.14998 13.25 4.14998H12.95V10.85H13.25C13.747 10.85 14.15 11.2529 14.15 11.75V13.25C14.15 13.747 13.747 14.15 13.25 14.15H11.75C11.2529 14.15 10.85 13.747 10.85 13.25V12.95H4.14998V13.25C4.14998 13.747 3.74703 14.15 3.24998 14.15H1.74998C1.25292 14.15 0.849976 13.747 0.849976 13.25V11.75C0.849976 11.2529 1.25292 10.85 1.74998 10.85H2.04998V4.14998H1.74998C1.25292 4.14998 0.849976 3.74703 0.849976 3.24998V1.74998ZM2.94998 4.14998V10.85H3.24998C3.74703 10.85 4.14998 11.2529 4.14998 11.75V12.05H10.85V11.75C10.85 11.2529 11.2529 10.85 11.75 10.85H12.05V4.14998H11.75C11.2529 4.14998 10.85 3.74703 10.85 3.24998V2.94998H4.14998V3.24998C4.14998 3.74703 3.74703 4.14998 3.24998 4.14998H2.94998ZM2.34998 1.74998H1.74998V2.34998V2.64998V3.24998H2.34998H2.64998H3.24998V2.64998V2.34998V1.74998H2.64998H2.34998ZM5.09998 5.99998C5.09998 5.50292 5.50292 5.09998 5.99998 5.09998H6.99998C7.49703 5.09998 7.89998 5.50292 7.89998 5.99998V6.99998C7.89998 7.03591 7.89787 7.07134 7.89378 7.10618C7.92861 7.10208 7.96405 7.09998 7.99998 7.09998H8.99998C9.49703 7.09998 9.89998 7.50292 9.89998 7.99998V8.99998C9.89998 9.49703 9.49703 9.89998 8.99998 9.89998H7.99998C7.50292 9.89998 7.09998 9.49703 7.09998 8.99998V7.99998C7.09998 7.96405 7.10208 7.92861 7.10618 7.89378C7.07134 7.89787 7.03591 7.89998 6.99998 7.89998H5.99998C5.50292 7.89998 5.09998 7.49703 5.09998 6.99998V5.99998ZM6.09998 5.99998H5.99998V6.09998V6.89998V6.99998H6.09998H6.89998H6.99998V6.89998V6.09998V5.99998H6.89998H6.09998ZM7.99998 7.99998H8.09998H8.89998H8.99998V8.09998V8.89998V8.99998H8.89998H8.09998H7.99998V8.89998V8.09998V7.99998ZM2.64998 11.75H2.34998H1.74998V12.35V12.65V13.25H2.34998H2.64998H3.24998V12.65V12.35V11.75H2.64998ZM11.75 1.74998H12.35H12.65H13.25V2.34998V2.64998V3.24998H12.65H12.35H11.75V2.64998V2.34998V1.74998ZM12.65 11.75H12.35H11.75V12.35V12.65V13.25H12.35H12.65H13.25V12.65V12.35V11.75H12.65Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Experienced Mentors",
              desc: "Learn from professionals with lots of industry experience."
          },
          {
              id: "2",
              icon: ( <svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M3.00014 2.73895C3.00014 2.94698 2.76087 3.06401 2.59666 2.93628L1.00386 1.69744C0.875177 1.59735 0.875177 1.40286 1.00386 1.30277L2.59666 0.063928C2.76087 -0.0637944 3.00014 0.0532293 3.00014 0.261266V1.00012H9.00009V0.261296C9.00009 0.0532591 9.23936 -0.0637646 9.40358 0.0639578L10.9964 1.3028C11.1251 1.40289 11.1251 1.59738 10.9964 1.69747L9.40358 2.93631C9.23936 3.06404 9.00009 2.94701 9.00009 2.73898V2.00012H3.00014V2.73895ZM9.50002 4.99998H2.50002C2.22388 4.99998 2.00002 5.22384 2.00002 5.49998V12.5C2.00002 12.7761 2.22388 13 2.50002 13H9.50002C9.77616 13 10 12.7761 10 12.5V5.49998C10 5.22384 9.77616 4.99998 9.50002 4.99998ZM2.50002 3.99998C1.67159 3.99998 1.00002 4.67156 1.00002 5.49998V12.5C1.00002 13.3284 1.67159 14 2.50002 14H9.50002C10.3284 14 11 13.3284 11 12.5V5.49998C11 4.67156 10.3284 3.99998 9.50002 3.99998H2.50002ZM14.7389 6.00001H14V12H14.7389C14.9469 12 15.064 12.2393 14.9362 12.4035L13.6974 13.9963C13.5973 14.125 13.4028 14.125 13.3027 13.9963L12.0639 12.4035C11.9362 12.2393 12.0532 12 12.2612 12H13V6.00001H12.2612C12.0532 6.00001 11.9361 5.76074 12.0639 5.59653L13.3027 4.00373C13.4028 3.87505 13.5973 3.87505 13.6974 4.00374L14.9362 5.59653C15.0639 5.76074 14.9469 6.00001 14.7389 6.00001Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Practical Curriculum",
              desc: "Build a strong portfolio with real-world projects and case studies."
          },
          {
              id: "3",
              icon: (<svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M1 2C0.447715 2 0 2.44772 0 3V12C0 12.5523 0.447715 13 1 13H14C14.5523 13 15 12.5523 15 12V3C15 2.44772 14.5523 2 14 2H1ZM1 3L14 3V3.92494C13.9174 3.92486 13.8338 3.94751 13.7589 3.99505L7.5 7.96703L1.24112 3.99505C1.16621 3.94751 1.0826 3.92486 1 3.92494V3ZM1 4.90797V12H14V4.90797L7.74112 8.87995C7.59394 8.97335 7.40606 8.97335 7.25888 8.87995L1 4.90797Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Career Guidance",
              desc: "Get help with resume building, interview prep, and industry connections."
          },
          {
              id: "4",
              icon: ( <svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M4.5 2C3.11929 2 2 3.11929 2 4.5C2 5.88072 3.11929 7 4.5 7C5.88072 7 7 5.88072 7 4.5C7 3.11929 5.88072 2 4.5 2ZM3 4.5C3 3.67157 3.67157 3 4.5 3C5.32843 3 6 3.67157 6 4.5C6 5.32843 5.32843 6 4.5 6C3.67157 6 3 5.32843 3 4.5ZM10.5 2C9.11929 2 8 3.11929 8 4.5C8 5.88072 9.11929 7 10.5 7C11.8807 7 13 5.88072 13 4.5C13 3.11929 11.8807 2 10.5 2ZM9 4.5C9 3.67157 9.67157 3 10.5 3C11.3284 3 12 3.67157 12 4.5C12 5.32843 11.3284 6 10.5 6C9.67157 6 9 5.32843 9 4.5ZM2 10.5C2 9.11929 3.11929 8 4.5 8C5.88072 8 7 9.11929 7 10.5C7 11.8807 5.88072 13 4.5 13C3.11929 13 2 11.8807 2 10.5ZM4.5 9C3.67157 9 3 9.67157 3 10.5C3 11.3284 3.67157 12 4.5 12C5.32843 12 6 11.3284 6 10.5C6 9.67157 5.32843 9 4.5 9ZM10.5 8C9.11929 8 8 9.11929 8 10.5C8 11.8807 9.11929 13 10.5 13C11.8807 13 13 11.8807 13 10.5C13 9.11929 11.8807 8 10.5 8ZM9 10.5C9 9.67157 9.67157 9 10.5 9C11.3284 9 12 9.67157 12 10.5C12 11.3284 11.3284 12 10.5 12C9.67157 12 9 11.3284 9 10.5Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Industry-Standard Tools",
              desc: "Learn the latest design software and prototyping tools used by top companies."
          },
          {
              id: "5",
              icon: (<svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M9.96424 2.68571C10.0668 2.42931 9.94209 2.13833 9.6857 2.03577C9.4293 1.93322 9.13832 2.05792 9.03576 2.31432L5.03576 12.3143C4.9332 12.5707 5.05791 12.8617 5.3143 12.9642C5.5707 13.0668 5.86168 12.9421 5.96424 12.6857L9.96424 2.68571ZM3.85355 5.14646C4.04882 5.34172 4.04882 5.6583 3.85355 5.85356L2.20711 7.50001L3.85355 9.14646C4.04882 9.34172 4.04882 9.6583 3.85355 9.85356C3.65829 10.0488 3.34171 10.0488 3.14645 9.85356L1.14645 7.85356C0.951184 7.6583 0.951184 7.34172 1.14645 7.14646L3.14645 5.14646C3.34171 4.9512 3.65829 4.9512 3.85355 5.14646ZM11.1464 5.14646C11.3417 4.9512 11.6583 4.9512 11.8536 5.14646L13.8536 7.14646C14.0488 7.34172 14.0488 7.6583 13.8536 7.85356L11.8536 9.85356C11.6583 10.0488 11.3417 10.0488 11.1464 9.85356C10.9512 9.6583 10.9512 9.34172 11.1464 9.14646L12.7929 7.50001L11.1464 5.85356C10.9512 5.6583 10.9512 5.34172 11.1464 5.14646Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Design Community",
              desc: "Join a network of aspiring and professional designers for inspiration and collaboration."
          },
          {
              id: "6",
              icon: ( <svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M7.28856 0.796908C7.42258 0.734364 7.57742 0.734364 7.71144 0.796908L13.7114 3.59691C13.8875 3.67906 14 3.85574 14 4.05V10.95C14 11.1443 13.8875 11.3209 13.7114 11.4031L7.71144 14.2031C7.57742 14.2656 7.42258 14.2656 7.28856 14.2031L1.28856 11.4031C1.11252 11.3209 1 11.1443 1 10.95V4.05C1 3.85574 1.11252 3.67906 1.28856 3.59691L7.28856 0.796908ZM2 4.80578L7 6.93078V12.9649L2 10.6316V4.80578ZM8 12.9649L13 10.6316V4.80578L8 6.93078V12.9649ZM7.5 6.05672L12.2719 4.02866L7.5 1.80176L2.72809 4.02866L7.5 6.05672Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Modern Design Lab",
              desc: "Use our well-equipped design studio with the latest hardware and software."
          },
      ]
     
  },
  {
      id: "4",
      title: "What You'll Learn",
      sub_title:"Gain essential UI/UX design skills and methods to create user-friendly and visually appealing digital experiences that boost business growth.",
      Course_img: [
          {
              id: "1",
              img: "https://img.freepik.com/free-photo/close-up-shot-video-graphic-editor-using-specialized-software-edit-movie-footage-improve-visual-quality-professional-videographer-sitting-multi-monitor-workstation-enhancing-film-frames_482257-43894.jpg?t=st=1720781917~exp=1720785517~hmac=81511424dc55688702376d38724a5fae03e88a053eb941919d5e0e51586d7629&w=360",
              title: "Photoshop",
              alt: "Photoshop"
          },
          {
              id: "2",
              img: "https://img.freepik.com/free-vector/flat-creativity-concept-illustration_52683-64279.jpg?t=st=1720780069~exp=1720783669~hmac=7f85521d4ab1fa1a94c6d7540e449cd39ad8d0733512d57d4cddebf8456d8d64&w=740",
              title: "Illustrator",
              alt: "Illustrator"
          },
          {
              id: "4",
              img: "https://i0.wp.com/bytes.com.ng/wp-content/uploads/2022/05/coreldraw-logo.png?fit=1270%2C1432&ssl=1",
              title: "Coraldraw",
              alt: "Coraldraw"
          },
      ]
  },
  {
      id: "5",
      title: "Frequently Asked Questions (FAQs)",
      sub_title: "Have questions about our UI/UX Design course? Here are answers to some common questions to help you out.",
      faqs: [
         {
          id: "1",
          heading: "Who is this course suitable for?",
          sub_heading: "This course is great for anyone with a background in graphic design, web development, or a strong interest in digital design and user behavior.",
         },
         {
          id: "2",
          heading: " What tools will I learn to use?",
          sub_heading: "You’ll learn to use popular tools like Adobe XD, Sketch, Figma, and InVision. We’ll provide access to these tools during the course.",
         },
         {
          id: "3",
          heading: "Is there a final project?",
          sub_heading: "Yes, you’ll complete a capstone project where you’ll design a full UI/UX solution for a real-world problem, which will be an important part of your portfolio.",
         },
         {
          id: "4",
          heading: " Can I take this course if I have no design background?",
          sub_heading: "Absolutely! While some design knowledge is helpful, our course is designed for beginners and will guide you through the basics.",
         },
         {
          id: "5",
          heading: "Are there job placement opportunities after the course?",
          sub_heading: "Yes, we offer career support services, including portfolio reviews, mock interviews, and connections with industry partners to help you find job opportunities.",
         },
      ]
  }
]

export const DigitalMarketing = [
  {
      id: "1",
      small_text: "Start your career as a Digital Marketing",
      name: "Digital Marketing Course In Kurukshetra",
      duration_One : "3-6 Months",
      description: "In today’s connected world, digital marketing is key to business success. There is a high demand for marketers who can effectively work in the digital space. At BrainboxStudy, we provide complete training in digital marketing strategies and tools. Our goal is to help you gain the skills needed to succeed in this exciting field. Join us and start your career in digital marketing!",
      image: "/degital.png",
      alt: 'degital',
      join_btn: "Join Now",
  },
  {
      id: "2",
      main_image: "https://img.freepik.com/free-photo/digital-marketing-with-icons-business-people_53876-94833.jpg?t=st=1720781518~exp=1720785118~hmac=8e76fc212ca30c1c58ee76ece0bbf83485abaa687559141a838916f166316558&w=740",
      small_text_one: "Digital Marketing Course",
      alt: 'Digital Marketing',
      title: "Digital Marketing Course in Kurukshetra: Why Choose This Career?",
      desc: "In today’s digital marketplace, businesses of all sizes need skilled professionals to manage their online presence and marketing efforts. This career combines creativity with data analysis, helping you create effective campaigns and measure their success. Our Digital Marketing Course in Kurukshetra is perfect for those who want to lead in modern marketing strategies. Whether you're a recent graduate or a professional looking to improve your skills, digital marketing offers many benefits. It provides various career opportunities, ensures ongoing learning in a fast-changing field, and allows you to work in different industries. As companies invest more in digital channels, digital marketers are essential for shaping brand image and driving business growth.",
      visit_btn: " Visit the help center"
  },
  {
      id: "3",
      title: "Why Choose BrainboxStudy for Digital Marketing?",
      sub_title: "Start your journey to becoming a skilled digital marketer with our relevant courses.",
      feature: [
          {
              id: "1",
              icon: ( <svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M0.849976 1.74998C0.849976 1.25292 1.25292 0.849976 1.74998 0.849976H3.24998C3.74703 0.849976 4.14998 1.25292 4.14998 1.74998V2.04998H10.85V1.74998C10.85 1.25292 11.2529 0.849976 11.75 0.849976H13.25C13.747 0.849976 14.15 1.25292 14.15 1.74998V3.24998C14.15 3.74703 13.747 4.14998 13.25 4.14998H12.95V10.85H13.25C13.747 10.85 14.15 11.2529 14.15 11.75V13.25C14.15 13.747 13.747 14.15 13.25 14.15H11.75C11.2529 14.15 10.85 13.747 10.85 13.25V12.95H4.14998V13.25C4.14998 13.747 3.74703 14.15 3.24998 14.15H1.74998C1.25292 14.15 0.849976 13.747 0.849976 13.25V11.75C0.849976 11.2529 1.25292 10.85 1.74998 10.85H2.04998V4.14998H1.74998C1.25292 4.14998 0.849976 3.74703 0.849976 3.24998V1.74998ZM2.94998 4.14998V10.85H3.24998C3.74703 10.85 4.14998 11.2529 4.14998 11.75V12.05H10.85V11.75C10.85 11.2529 11.2529 10.85 11.75 10.85H12.05V4.14998H11.75C11.2529 4.14998 10.85 3.74703 10.85 3.24998V2.94998H4.14998V3.24998C4.14998 3.74703 3.74703 4.14998 3.24998 4.14998H2.94998ZM2.34998 1.74998H1.74998V2.34998V2.64998V3.24998H2.34998H2.64998H3.24998V2.64998V2.34998V1.74998H2.64998H2.34998ZM5.09998 5.99998C5.09998 5.50292 5.50292 5.09998 5.99998 5.09998H6.99998C7.49703 5.09998 7.89998 5.50292 7.89998 5.99998V6.99998C7.89998 7.03591 7.89787 7.07134 7.89378 7.10618C7.92861 7.10208 7.96405 7.09998 7.99998 7.09998H8.99998C9.49703 7.09998 9.89998 7.50292 9.89998 7.99998V8.99998C9.89998 9.49703 9.49703 9.89998 8.99998 9.89998H7.99998C7.50292 9.89998 7.09998 9.49703 7.09998 8.99998V7.99998C7.09998 7.96405 7.10208 7.92861 7.10618 7.89378C7.07134 7.89787 7.03591 7.89998 6.99998 7.89998H5.99998C5.50292 7.89998 5.09998 7.49703 5.09998 6.99998V5.99998ZM6.09998 5.99998H5.99998V6.09998V6.89998V6.99998H6.09998H6.89998H6.99998V6.89998V6.09998V5.99998H6.89998H6.09998ZM7.99998 7.99998H8.09998H8.89998H8.99998V8.09998V8.89998V8.99998H8.89998H8.09998H7.99998V8.89998V8.09998V7.99998ZM2.64998 11.75H2.34998H1.74998V12.35V12.65V13.25H2.34998H2.64998H3.24998V12.65V12.35V11.75H2.64998ZM11.75 1.74998H12.35H12.65H13.25V2.34998V2.64998V3.24998H12.65H12.35H11.75V2.64998V2.34998V1.74998ZM12.65 11.75H12.35H11.75V12.35V12.65V13.25H12.35H12.65H13.25V12.65V12.35V11.75H12.65Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Industry Experts",
              desc: "Learn from experienced digital marketing professionals with successful backgrounds."
          },
          {
              id: "2",
              icon: ( <svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M3.00014 2.73895C3.00014 2.94698 2.76087 3.06401 2.59666 2.93628L1.00386 1.69744C0.875177 1.59735 0.875177 1.40286 1.00386 1.30277L2.59666 0.063928C2.76087 -0.0637944 3.00014 0.0532293 3.00014 0.261266V1.00012H9.00009V0.261296C9.00009 0.0532591 9.23936 -0.0637646 9.40358 0.0639578L10.9964 1.3028C11.1251 1.40289 11.1251 1.59738 10.9964 1.69747L9.40358 2.93631C9.23936 3.06404 9.00009 2.94701 9.00009 2.73898V2.00012H3.00014V2.73895ZM9.50002 4.99998H2.50002C2.22388 4.99998 2.00002 5.22384 2.00002 5.49998V12.5C2.00002 12.7761 2.22388 13 2.50002 13H9.50002C9.77616 13 10 12.7761 10 12.5V5.49998C10 5.22384 9.77616 4.99998 9.50002 4.99998ZM2.50002 3.99998C1.67159 3.99998 1.00002 4.67156 1.00002 5.49998V12.5C1.00002 13.3284 1.67159 14 2.50002 14H9.50002C10.3284 14 11 13.3284 11 12.5V5.49998C11 4.67156 10.3284 3.99998 9.50002 3.99998H2.50002ZM14.7389 6.00001H14V12H14.7389C14.9469 12 15.064 12.2393 14.9362 12.4035L13.6974 13.9963C13.5973 14.125 13.4028 14.125 13.3027 13.9963L12.0639 12.4035C11.9362 12.2393 12.0532 12 12.2612 12H13V6.00001H12.2612C12.0532 6.00001 11.9361 5.76074 12.0639 5.59653L13.3027 4.00373C13.4028 3.87505 13.5973 3.87505 13.6974 4.00374L14.9362 5.59653C15.0639 5.76074 14.9469 6.00001 14.7389 6.00001Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Practical Approach",
              desc: "Get hands-on experience through real projects and managing live campaigns."
          },
          {
              id: "3",
              icon: (<svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M1 2C0.447715 2 0 2.44772 0 3V12C0 12.5523 0.447715 13 1 13H14C14.5523 13 15 12.5523 15 12V3C15 2.44772 14.5523 2 14 2H1ZM1 3L14 3V3.92494C13.9174 3.92486 13.8338 3.94751 13.7589 3.99505L7.5 7.96703L1.24112 3.99505C1.16621 3.94751 1.0826 3.92486 1 3.92494V3ZM1 4.90797V12H14V4.90797L7.74112 8.87995C7.59394 8.97335 7.40606 8.97335 7.25888 8.87995L1 4.90797Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Career Assistance",
              desc: "Benefit from job placement support, personal branding tips, and networking opportunities."
          },
          {
              id: "4",
              icon: ( <svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M4.5 2C3.11929 2 2 3.11929 2 4.5C2 5.88072 3.11929 7 4.5 7C5.88072 7 7 5.88072 7 4.5C7 3.11929 5.88072 2 4.5 2ZM3 4.5C3 3.67157 3.67157 3 4.5 3C5.32843 3 6 3.67157 6 4.5C6 5.32843 5.32843 6 4.5 6C3.67157 6 3 5.32843 3 4.5ZM10.5 2C9.11929 2 8 3.11929 8 4.5C8 5.88072 9.11929 7 10.5 7C11.8807 7 13 5.88072 13 4.5C13 3.11929 11.8807 2 10.5 2ZM9 4.5C9 3.67157 9.67157 3 10.5 3C11.3284 3 12 3.67157 12 4.5C12 5.32843 11.3284 6 10.5 6C9.67157 6 9 5.32843 9 4.5ZM2 10.5C2 9.11929 3.11929 8 4.5 8C5.88072 8 7 9.11929 7 10.5C7 11.8807 5.88072 13 4.5 13C3.11929 13 2 11.8807 2 10.5ZM4.5 9C3.67157 9 3 9.67157 3 10.5C3 11.3284 3.67157 12 4.5 12C5.32843 12 6 11.3284 6 10.5C6 9.67157 5.32843 9 4.5 9ZM10.5 8C9.11929 8 8 9.11929 8 10.5C8 11.8807 9.11929 13 10.5 13C11.8807 13 13 11.8807 13 10.5C13 9.11929 11.8807 8 10.5 8ZM9 10.5C9 9.67157 9.67157 9 10.5 9C11.3284 9 12 9.67157 12 10.5C12 11.3284 11.3284 12 10.5 12C9.67157 12 9 11.3284 9 10.5Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Latest Tools & Techniques",
              desc: "Stay updated with training on modern marketing platforms and analytics tools."
          },
          {
              id: "5",
              icon: (<svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M9.96424 2.68571C10.0668 2.42931 9.94209 2.13833 9.6857 2.03577C9.4293 1.93322 9.13832 2.05792 9.03576 2.31432L5.03576 12.3143C4.9332 12.5707 5.05791 12.8617 5.3143 12.9642C5.5707 13.0668 5.86168 12.9421 5.96424 12.6857L9.96424 2.68571ZM3.85355 5.14646C4.04882 5.34172 4.04882 5.6583 3.85355 5.85356L2.20711 7.50001L3.85355 9.14646C4.04882 9.34172 4.04882 9.6583 3.85355 9.85356C3.65829 10.0488 3.34171 10.0488 3.14645 9.85356L1.14645 7.85356C0.951184 7.6583 0.951184 7.34172 1.14645 7.14646L3.14645 5.14646C3.34171 4.9512 3.65829 4.9512 3.85355 5.14646ZM11.1464 5.14646C11.3417 4.9512 11.6583 4.9512 11.8536 5.14646L13.8536 7.14646C14.0488 7.34172 14.0488 7.6583 13.8536 7.85356L11.8536 9.85356C11.6583 10.0488 11.3417 10.0488 11.1464 9.85356C10.9512 9.6583 10.9512 9.34172 11.1464 9.14646L12.7929 7.50001L11.1464 5.85356C10.9512 5.6583 10.9512 5.34172 11.1464 5.14646Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Marketing Network",
              desc: "Join a community of aspiring and professional marketers to share knowledge and collaborate."
          },
          {
              id: "6",
              icon: ( <svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M7.28856 0.796908C7.42258 0.734364 7.57742 0.734364 7.71144 0.796908L13.7114 3.59691C13.8875 3.67906 14 3.85574 14 4.05V10.95C14 11.1443 13.8875 11.3209 13.7114 11.4031L7.71144 14.2031C7.57742 14.2656 7.42258 14.2656 7.28856 14.2031L1.28856 11.4031C1.11252 11.3209 1 11.1443 1 10.95V4.05C1 3.85574 1.11252 3.67906 1.28856 3.59691L7.28856 0.796908ZM2 4.80578L7 6.93078V12.9649L2 10.6316V4.80578ZM8 12.9649L13 10.6316V4.80578L8 6.93078V12.9649ZM7.5 6.05672L12.2719 4.02866L7.5 1.80176L2.72809 4.02866L7.5 6.05672Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Virtual Marketing Lab",
              desc: "Use our online resources and tools to practice and improve your digital marketing skills."
          },
      ]
     
  },
  {
      id: "4",
      title: "What You'll Learn",
      sub_title:"Learn key digital marketing skills and strategies to create, run, and improve marketing campaigns on different digital platforms.",
      Course_img: [
          {
              id: "1",
              img: "https://img.freepik.com/free-photo/magnifying-glass-with-seo-concepts_1134-81.jpg?t=st=1720782838~exp=1720786438~hmac=6306d3a4c92de47afbfb652d226d695b22ae88690f87d1922c316a46fdc6e451&w=740",
              title: "SEO",
              alt: "SEO"
          },
          {
              id: "2",
              img: "https://img.freepik.com/premium-photo/bright-technology-display-search-engine-marketing_23-2150783904.jpg?w=740",
              title: "SEM",
              alt: "SEM"
          },
          {
              id: "4",
              img: "https://img.freepik.com/premium-vector/flat-design-pay-per-click-marketing-strategy_108061-1239.jpg?w=740",
              title: "Google Ads and Bing Ads",
              alt: "Google Ads and Bing Ads"
          },
      ]
  },
  {
      id: "5",
      title: "Frequently Asked Questions (FAQs)",
      sub_title: "Still have questions about our Digital Marketing course? Here are some common questions to help you find the information you need.",
      faqs: [
         {
          id: "1",
          heading: "Who is this course for?",
          sub_heading: "This course is for anyone interested in marketing, communication, or business, as well as professionals looking to add digital skills.",
         },
         {
          id: "2",
          heading: " Do I need any prior marketing experience?",
          sub_heading: "No prior marketing experience is needed. We start with the basics and gradually move to more advanced topics.",
         },
         {
          id: "3",
          heading: "What tools will I learn to use?",
          sub_heading: "You’ll learn to use various tools, including Google Analytics, Google Ads, social media management platforms, email marketing software, and SEO tools.",
         },
         {
          id: "4",
          heading: " Is there a certification at the end of the course?",
          sub_heading: "Yes, once you successfully complete the course and its assessments, you’ll receive a certification in Digital Marketing from BrainboxStudy.",
         },
         {
          id: "5",
          heading: "How is the course structured?",
          sub_heading: "Absolutely! Our course is designed with flexibility in mind for working professionals. We offer various scheduling options and provide recorded lectures for review.",
         },
      ]
  }
]

export const Python = [
  {
      id: "1",
      small_text: "Start your career as a Python Programming",
      name: "Python Programming Course In Kurukshetra",
      duration_One : "3-6 Months",
      description: "In today’s data-driven world, Python has become one of the most flexible and in-demand programming languages. There is a rising need for developers who can use Python for different applications. At BrainboxStudy, we offer complete training in Python programming. Our goal is to help you gain the skills needed to succeed in this powerful language. Join us and open up many opportunities in the tech industry!",
      image: "/pythonicon.png",
      alt: 'pythonicon',
      join_btn: "Join Now",
  },
  {
      id: "2",
      main_image: "https://img.freepik.com/free-photo/html-css-collage-concept-with-person_23-2150062008.jpg?t=st=1720780742~exp=1720784342~hmac=340d7137d1143e60b95ec0eb253f5417e8c4ec43c2a8ec86023ec7ef18a28506&w=740",
      small_text_one: "Python Programming Course",
      alt: 'Python',
      title: "Python Programming Course In Kurukshetra: Why Choose This Career?",
      desc: "In the fast-changing tech industry, Python has become a popular language for many applications, from web development to artificial intelligence. This career combines logical thinking with creative problem-solving, allowing you to address various challenges in different fields. Our Python Programming Course in Kurukshetra is ideal for those who want to develop a versatile skill set in programming. Whether you’re a student starting your coding journey or a professional looking to learn a new skill, Python offers many advantages. It opens up career opportunities in software development, data analysis, machine learning, and more. As companies increasingly rely on data-driven decisions and automation, Python programmers are essential for driving innovation and efficiency.",
      visit_btn: " Visit the help center"
  },
  {
      id: "3",
      title: "Why Choose BrainboxStudy for Python Programming?",
      sub_title: "Start your journey to becoming a skilled Python programmer with our relevant courses.",
      feature: [
          {
              id: "1",
              icon: ( <svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M0.849976 1.74998C0.849976 1.25292 1.25292 0.849976 1.74998 0.849976H3.24998C3.74703 0.849976 4.14998 1.25292 4.14998 1.74998V2.04998H10.85V1.74998C10.85 1.25292 11.2529 0.849976 11.75 0.849976H13.25C13.747 0.849976 14.15 1.25292 14.15 1.74998V3.24998C14.15 3.74703 13.747 4.14998 13.25 4.14998H12.95V10.85H13.25C13.747 10.85 14.15 11.2529 14.15 11.75V13.25C14.15 13.747 13.747 14.15 13.25 14.15H11.75C11.2529 14.15 10.85 13.747 10.85 13.25V12.95H4.14998V13.25C4.14998 13.747 3.74703 14.15 3.24998 14.15H1.74998C1.25292 14.15 0.849976 13.747 0.849976 13.25V11.75C0.849976 11.2529 1.25292 10.85 1.74998 10.85H2.04998V4.14998H1.74998C1.25292 4.14998 0.849976 3.74703 0.849976 3.24998V1.74998ZM2.94998 4.14998V10.85H3.24998C3.74703 10.85 4.14998 11.2529 4.14998 11.75V12.05H10.85V11.75C10.85 11.2529 11.2529 10.85 11.75 10.85H12.05V4.14998H11.75C11.2529 4.14998 10.85 3.74703 10.85 3.24998V2.94998H4.14998V3.24998C4.14998 3.74703 3.74703 4.14998 3.24998 4.14998H2.94998ZM2.34998 1.74998H1.74998V2.34998V2.64998V3.24998H2.34998H2.64998H3.24998V2.64998V2.34998V1.74998H2.64998H2.34998ZM5.09998 5.99998C5.09998 5.50292 5.50292 5.09998 5.99998 5.09998H6.99998C7.49703 5.09998 7.89998 5.50292 7.89998 5.99998V6.99998C7.89998 7.03591 7.89787 7.07134 7.89378 7.10618C7.92861 7.10208 7.96405 7.09998 7.99998 7.09998H8.99998C9.49703 7.09998 9.89998 7.50292 9.89998 7.99998V8.99998C9.89998 9.49703 9.49703 9.89998 8.99998 9.89998H7.99998C7.50292 9.89998 7.09998 9.49703 7.09998 8.99998V7.99998C7.09998 7.96405 7.10208 7.92861 7.10618 7.89378C7.07134 7.89787 7.03591 7.89998 6.99998 7.89998H5.99998C5.50292 7.89998 5.09998 7.49703 5.09998 6.99998V5.99998ZM6.09998 5.99998H5.99998V6.09998V6.89998V6.99998H6.09998H6.89998H6.99998V6.89998V6.09998V5.99998H6.89998H6.09998ZM7.99998 7.99998H8.09998H8.89998H8.99998V8.09998V8.89998V8.99998H8.89998H8.09998H7.99998V8.89998V8.09998V7.99998ZM2.64998 11.75H2.34998H1.74998V12.35V12.65V13.25H2.34998H2.64998H3.24998V12.65V12.35V11.75H2.64998ZM11.75 1.74998H12.35H12.65H13.25V2.34998V2.64998V3.24998H12.65H12.35H11.75V2.64998V2.34998V1.74998ZM12.65 11.75H12.35H11.75V12.35V12.65V13.25H12.35H12.65H13.25V12.65V12.35V11.75H12.65Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Skilled Instructors",
              desc: "Learn from experienced Python developers who have worked on real projects."
          },
          {
              id: "2",
              icon: ( <svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M3.00014 2.73895C3.00014 2.94698 2.76087 3.06401 2.59666 2.93628L1.00386 1.69744C0.875177 1.59735 0.875177 1.40286 1.00386 1.30277L2.59666 0.063928C2.76087 -0.0637944 3.00014 0.0532293 3.00014 0.261266V1.00012H9.00009V0.261296C9.00009 0.0532591 9.23936 -0.0637646 9.40358 0.0639578L10.9964 1.3028C11.1251 1.40289 11.1251 1.59738 10.9964 1.69747L9.40358 2.93631C9.23936 3.06404 9.00009 2.94701 9.00009 2.73898V2.00012H3.00014V2.73895ZM9.50002 4.99998H2.50002C2.22388 4.99998 2.00002 5.22384 2.00002 5.49998V12.5C2.00002 12.7761 2.22388 13 2.50002 13H9.50002C9.77616 13 10 12.7761 10 12.5V5.49998C10 5.22384 9.77616 4.99998 9.50002 4.99998ZM2.50002 3.99998C1.67159 3.99998 1.00002 4.67156 1.00002 5.49998V12.5C1.00002 13.3284 1.67159 14 2.50002 14H9.50002C10.3284 14 11 13.3284 11 12.5V5.49998C11 4.67156 10.3284 3.99998 9.50002 3.99998H2.50002ZM14.7389 6.00001H14V12H14.7389C14.9469 12 15.064 12.2393 14.9362 12.4035L13.6974 13.9963C13.5973 14.125 13.4028 14.125 13.3027 13.9963L12.0639 12.4035C11.9362 12.2393 12.0532 12 12.2612 12H13V6.00001H12.2612C12.0532 6.00001 11.9361 5.76074 12.0639 5.59653L13.3027 4.00373C13.4028 3.87505 13.5973 3.87505 13.6974 4.00374L14.9362 5.59653C15.0639 5.76074 14.9469 6.00001 14.7389 6.00001Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Hands-on Curriculum",
              desc: "Gain practical skills through coding exercises, projects, and interactive sessions."
          },
          {
              id: "3",
              icon: (<svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M1 2C0.447715 2 0 2.44772 0 3V12C0 12.5523 0.447715 13 1 13H14C14.5523 13 15 12.5523 15 12V3C15 2.44772 14.5523 2 14 2H1ZM1 3L14 3V3.92494C13.9174 3.92486 13.8338 3.94751 13.7589 3.99505L7.5 7.96703L1.24112 3.99505C1.16621 3.94751 1.0826 3.92486 1 3.92494V3ZM1 4.90797V12H14V4.90797L7.74112 8.87995C7.59394 8.97335 7.40606 8.97335 7.25888 8.87995L1 4.90797Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Career Support",
              desc: "Get help with job placement, building your project portfolio, and connecting with industry professionals."
          },
          {
              id: "4",
              icon: ( <svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M4.5 2C3.11929 2 2 3.11929 2 4.5C2 5.88072 3.11929 7 4.5 7C5.88072 7 7 5.88072 7 4.5C7 3.11929 5.88072 2 4.5 2ZM3 4.5C3 3.67157 3.67157 3 4.5 3C5.32843 3 6 3.67157 6 4.5C6 5.32843 5.32843 6 4.5 6C3.67157 6 3 5.32843 3 4.5ZM10.5 2C9.11929 2 8 3.11929 8 4.5C8 5.88072 9.11929 7 10.5 7C11.8807 7 13 5.88072 13 4.5C13 3.11929 11.8807 2 10.5 2ZM9 4.5C9 3.67157 9.67157 3 10.5 3C11.3284 3 12 3.67157 12 4.5C12 5.32843 11.3284 6 10.5 6C9.67157 6 9 5.32843 9 4.5ZM2 10.5C2 9.11929 3.11929 8 4.5 8C5.88072 8 7 9.11929 7 10.5C7 11.8807 5.88072 13 4.5 13C3.11929 13 2 11.8807 2 10.5ZM4.5 9C3.67157 9 3 9.67157 3 10.5C3 11.3284 3.67157 12 4.5 12C5.32843 12 6 11.3284 6 10.5C6 9.67157 5.32843 9 4.5 9ZM10.5 8C9.11929 8 8 9.11929 8 10.5C8 11.8807 9.11929 13 10.5 13C11.8807 13 13 11.8807 13 10.5C13 9.11929 11.8807 8 10.5 8ZM9 10.5C9 9.67157 9.67157 9 10.5 9C11.3284 9 12 9.67157 12 10.5C12 11.3284 11.3284 12 10.5 12C9.67157 12 9 11.3284 9 10.5Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Diverse Applications",
              desc: "Discover Python’s use in web development, data science, AI, and more."
          },
          {
              id: "5",
              icon: (<svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M9.96424 2.68571C10.0668 2.42931 9.94209 2.13833 9.6857 2.03577C9.4293 1.93322 9.13832 2.05792 9.03576 2.31432L5.03576 12.3143C4.9332 12.5707 5.05791 12.8617 5.3143 12.9642C5.5707 13.0668 5.86168 12.9421 5.96424 12.6857L9.96424 2.68571ZM3.85355 5.14646C4.04882 5.34172 4.04882 5.6583 3.85355 5.85356L2.20711 7.50001L3.85355 9.14646C4.04882 9.34172 4.04882 9.6583 3.85355 9.85356C3.65829 10.0488 3.34171 10.0488 3.14645 9.85356L1.14645 7.85356C0.951184 7.6583 0.951184 7.34172 1.14645 7.14646L3.14645 5.14646C3.34171 4.9512 3.65829 4.9512 3.85355 5.14646ZM11.1464 5.14646C11.3417 4.9512 11.6583 4.9512 11.8536 5.14646L13.8536 7.14646C14.0488 7.34172 14.0488 7.6583 13.8536 7.85356L11.8536 9.85356C11.6583 10.0488 11.3417 10.0488 11.1464 9.85356C10.9512 9.6583 10.9512 9.34172 11.1464 9.14646L12.7929 7.50001L11.1464 5.85356C10.9512 5.6583 10.9512 5.34172 11.1464 5.14646Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Coding Community",
              desc: "Connect with fellow learners and Python enthusiasts for collaborative learning."
          },
          {
              id: "6",
              icon: ( <svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M7.28856 0.796908C7.42258 0.734364 7.57742 0.734364 7.71144 0.796908L13.7114 3.59691C13.8875 3.67906 14 3.85574 14 4.05V10.95C14 11.1443 13.8875 11.3209 13.7114 11.4031L7.71144 14.2031C7.57742 14.2656 7.42258 14.2656 7.28856 14.2031L1.28856 11.4031C1.11252 11.3209 1 11.1443 1 10.95V4.05C1 3.85574 1.11252 3.67906 1.28856 3.59691L7.28856 0.796908ZM2 4.80578L7 6.93078V12.9649L2 10.6316V4.80578ZM8 12.9649L13 10.6316V4.80578L8 6.93078V12.9649ZM7.5 6.05672L12.2719 4.02866L7.5 1.80176L2.72809 4.02866L7.5 6.05672Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Modern Coding Lab",
              desc: "Use our well-equipped computer labs with the latest development tools."
          },
      ]
     
  },
  {
      id: "4",
      title: "What You'll Learn",
      sub_title:"Master essential Python programming concepts and libraries to create efficient and scalable applications and scripts for various uses.",
      Course_img: [
          {
              id: "1",
              img: "https://img.freepik.com/free-photo/html-css-collage-concept-with-person_23-2150061963.jpg?t=st=1720783094~exp=1720786694~hmac=571e6bc378b2fa95c029206e1b17368935446182a35806803f29ffe105b7cccf&w=740",
              title: "Core and Advanced Python",
              alt: "Core and Advanced Python"
          },
          {
              id: "2",
              img: "https://img.freepik.com/free-photo/programming-background-with-person-working-with-codes-computer_23-2150010125.jpg?t=st=1720782587~exp=1720786187~hmac=76a7b31846747282614cedbb1ef66a3b8f51506ec9362478acfd553bde6bd1ec&w=740",
              title: "Django",
              alt: "Django"
          },
          {
              id: "4",
              img: "https://img.freepik.com/free-vector/coding-round-composition_1284-40752.jpg?t=st=1720783220~exp=1720786820~hmac=c97cd1541f7bcfdf76bd5317109db850fcd7839ef73d5b48627144047d169b93&w=740",
              title: "Object-Oriented Programming",
              alt: "Object-Oriented Programming"
          },
      ]
  },
  {
      id: "5",
      title: "Frequently Asked Questions (FAQs)",
      sub_title: "Still have questions about our Python Programming course? Here are some common questions to help you find the answers you need.",
      faqs: [
         {
          id: "1",
          heading: "Who is this course suitable for?",
          sub_heading: "This course is for beginners with no prior programming experience, as well as those familiar with other languages who want to learn Python.",
         },
         {
          id: "2",
          heading: " Do I need any special software for this course?",
          sub_heading: "Python is free and open-source. We’ll help you with the installation process, and you’ll need a computer with internet access.",
         },
         {
          id: "3",
          heading: "How is the course structured?",
          sub_heading: "The course includes lectures, coding exercises, and projects. You’ll start with the basics and gradually move on to more advanced topics and real-world applications.",
         },
         {
          id: "4",
          heading: " Will I receive a certificate upon completion?",
          sub_heading: "Yes, you’ll receive a BrainboxStudy certificate in Python Programming after successfully completing the course and its assessments.",
         },
         {
          id: "5",
          heading: "What kind of projects will I work on?",
          sub_heading: "You’ll work on various projects, including simple games, data analysis tasks, web scraping, and a final capstone project of your choice.",
         },
      ]
  }
]

export const MachineLearning = [

  {
      id: "1",
      small_text: "Start your career as a Machine Learning",
      name: "Machine Learning course in kurukshetra",
      duration_One : "8 Months",
      description: "In today’s AI-driven world, Machine Learning is essential for technology innovation. There is a growing need for professionals who can create smart systems and analyze data. At BrainboxStudy, we provide complete training in Machine Learning. Our goal is to help you gain the skills needed to succeed in this exciting field. Join us and be part of the AI revolution!",
      image: "/machines.png",
      alt: "machines",
      join_btn: "Join Now",
  },
  {
      id: "2",
      main_image: "https://img.freepik.com/premium-photo/ai-chatbot-concept-is-unique-that-it-can-interact-as-naturally-as-real-human-industry-innovation-50_150418-1387.jpg?w=740",
      small_text_one: "Machine Learning Course",
      alt: 'Machine Learning',
      title: "Machine Learning Course In Kurukshetra: Why Choose This Career?",
      desc: "In today’s fast-changing tech world, Machine Learning is changing how industries operate. This career combines math, programming, and industry knowledge, helping you solve complex problems and create new solutions. Our Machine Learning Course in Kurukshetra is perfect for anyone passionate about AI and data-driven technology. Whether you’re a recent graduate or a professional looking to switch to AI, Machine Learning offers exciting opportunities. You can work on innovative projects, keep learning new skills, and make a real difference in various fields. As companies increasingly use Machine Learning for automation and predictions, Machine Learning engineers are vital for driving progress and business growth.",
      visit_btn: " Visit the help center"
  },
  {
      id: "3",
      title: "Why Choose BrainboxStudy for Machine Learning?",
      sub_title: "Start your journey to becoming a skilled Machine Learning professional with our practical courses.",
      feature: [
          {
              id: "1",
              icon: ( <svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M0.849976 1.74998C0.849976 1.25292 1.25292 0.849976 1.74998 0.849976H3.24998C3.74703 0.849976 4.14998 1.25292 4.14998 1.74998V2.04998H10.85V1.74998C10.85 1.25292 11.2529 0.849976 11.75 0.849976H13.25C13.747 0.849976 14.15 1.25292 14.15 1.74998V3.24998C14.15 3.74703 13.747 4.14998 13.25 4.14998H12.95V10.85H13.25C13.747 10.85 14.15 11.2529 14.15 11.75V13.25C14.15 13.747 13.747 14.15 13.25 14.15H11.75C11.2529 14.15 10.85 13.747 10.85 13.25V12.95H4.14998V13.25C4.14998 13.747 3.74703 14.15 3.24998 14.15H1.74998C1.25292 14.15 0.849976 13.747 0.849976 13.25V11.75C0.849976 11.2529 1.25292 10.85 1.74998 10.85H2.04998V4.14998H1.74998C1.25292 4.14998 0.849976 3.74703 0.849976 3.24998V1.74998ZM2.94998 4.14998V10.85H3.24998C3.74703 10.85 4.14998 11.2529 4.14998 11.75V12.05H10.85V11.75C10.85 11.2529 11.2529 10.85 11.75 10.85H12.05V4.14998H11.75C11.2529 4.14998 10.85 3.74703 10.85 3.24998V2.94998H4.14998V3.24998C4.14998 3.74703 3.74703 4.14998 3.24998 4.14998H2.94998ZM2.34998 1.74998H1.74998V2.34998V2.64998V3.24998H2.34998H2.64998H3.24998V2.64998V2.34998V1.74998H2.64998H2.34998ZM5.09998 5.99998C5.09998 5.50292 5.50292 5.09998 5.99998 5.09998H6.99998C7.49703 5.09998 7.89998 5.50292 7.89998 5.99998V6.99998C7.89998 7.03591 7.89787 7.07134 7.89378 7.10618C7.92861 7.10208 7.96405 7.09998 7.99998 7.09998H8.99998C9.49703 7.09998 9.89998 7.50292 9.89998 7.99998V8.99998C9.89998 9.49703 9.49703 9.89998 8.99998 9.89998H7.99998C7.50292 9.89998 7.09998 9.49703 7.09998 8.99998V7.99998C7.09998 7.96405 7.10208 7.92861 7.10618 7.89378C7.07134 7.89787 7.03591 7.89998 6.99998 7.89998H5.99998C5.50292 7.89998 5.09998 7.49703 5.09998 6.99998V5.99998ZM6.09998 5.99998H5.99998V6.09998V6.89998V6.99998H6.09998H6.89998H6.99998V6.89998V6.09998V5.99998H6.89998H6.09998ZM7.99998 7.99998H8.09998H8.89998H8.99998V8.09998V8.89998V8.99998H8.89998H8.09998H7.99998V8.89998V8.09998V7.99998ZM2.64998 11.75H2.34998H1.74998V12.35V12.65V13.25H2.34998H2.64998H3.24998V12.65V12.35V11.75H2.64998ZM11.75 1.74998H12.35H12.65H13.25V2.34998V2.64998V3.24998H12.65H12.35H11.75V2.64998V2.34998V1.74998ZM12.65 11.75H12.35H11.75V12.35V12.65V13.25H12.35H12.65H13.25V12.65V12.35V11.75H12.65Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Expert Faculty",
              desc: "Learn from experienced ML professionals and researchers."
          },
          {
              id: "2",
              icon: ( <svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M3.00014 2.73895C3.00014 2.94698 2.76087 3.06401 2.59666 2.93628L1.00386 1.69744C0.875177 1.59735 0.875177 1.40286 1.00386 1.30277L2.59666 0.063928C2.76087 -0.0637944 3.00014 0.0532293 3.00014 0.261266V1.00012H9.00009V0.261296C9.00009 0.0532591 9.23936 -0.0637646 9.40358 0.0639578L10.9964 1.3028C11.1251 1.40289 11.1251 1.59738 10.9964 1.69747L9.40358 2.93631C9.23936 3.06404 9.00009 2.94701 9.00009 2.73898V2.00012H3.00014V2.73895ZM9.50002 4.99998H2.50002C2.22388 4.99998 2.00002 5.22384 2.00002 5.49998V12.5C2.00002 12.7761 2.22388 13 2.50002 13H9.50002C9.77616 13 10 12.7761 10 12.5V5.49998C10 5.22384 9.77616 4.99998 9.50002 4.99998ZM2.50002 3.99998C1.67159 3.99998 1.00002 4.67156 1.00002 5.49998V12.5C1.00002 13.3284 1.67159 14 2.50002 14H9.50002C10.3284 14 11 13.3284 11 12.5V5.49998C11 4.67156 10.3284 3.99998 9.50002 3.99998H2.50002ZM14.7389 6.00001H14V12H14.7389C14.9469 12 15.064 12.2393 14.9362 12.4035L13.6974 13.9963C13.5973 14.125 13.4028 14.125 13.3027 13.9963L12.0639 12.4035C11.9362 12.2393 12.0532 12 12.2612 12H13V6.00001H12.2612C12.0532 6.00001 11.9361 5.76074 12.0639 5.59653L13.3027 4.00373C13.4028 3.87505 13.5973 3.87505 13.6974 4.00374L14.9362 5.59653C15.0639 5.76074 14.9469 6.00001 14.7389 6.00001Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Comprehensive Curriculum",
              desc: "Build a strong foundation in ML theory and gain hands-on experience with real projects."
          },
          {
              id: "3",
              icon: (<svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M1 2C0.447715 2 0 2.44772 0 3V12C0 12.5523 0.447715 13 1 13H14C14.5523 13 15 12.5523 15 12V3C15 2.44772 14.5523 2 14 2H1ZM1 3L14 3V3.92494C13.9174 3.92486 13.8338 3.94751 13.7589 3.99505L7.5 7.96703L1.24112 3.99505C1.16621 3.94751 1.0826 3.92486 1 3.92494V3ZM1 4.90797V12H14V4.90797L7.74112 8.87995C7.59394 8.97335 7.40606 8.97335 7.25888 8.87995L1 4.90797Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Career Advancement",
              desc: "Get help with your resume, interview preparation, and connections to top tech companies."
          },
          {
              id: "4",
              icon: ( <svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M4.5 2C3.11929 2 2 3.11929 2 4.5C2 5.88072 3.11929 7 4.5 7C5.88072 7 7 5.88072 7 4.5C7 3.11929 5.88072 2 4.5 2ZM3 4.5C3 3.67157 3.67157 3 4.5 3C5.32843 3 6 3.67157 6 4.5C6 5.32843 5.32843 6 4.5 6C3.67157 6 3 5.32843 3 4.5ZM10.5 2C9.11929 2 8 3.11929 8 4.5C8 5.88072 9.11929 7 10.5 7C11.8807 7 13 5.88072 13 4.5C13 3.11929 11.8807 2 10.5 2ZM9 4.5C9 3.67157 9.67157 3 10.5 3C11.3284 3 12 3.67157 12 4.5C12 5.32843 11.3284 6 10.5 6C9.67157 6 9 5.32843 9 4.5ZM2 10.5C2 9.11929 3.11929 8 4.5 8C5.88072 8 7 9.11929 7 10.5C7 11.8807 5.88072 13 4.5 13C3.11929 13 2 11.8807 2 10.5ZM4.5 9C3.67157 9 3 9.67157 3 10.5C3 11.3284 3.67157 12 4.5 12C5.32843 12 6 11.3284 6 10.5C6 9.67157 5.32843 9 4.5 9ZM10.5 8C9.11929 8 8 9.11929 8 10.5C8 11.8807 9.11929 13 10.5 13C11.8807 13 13 11.8807 13 10.5C13 9.11929 11.8807 8 10.5 8ZM9 10.5C9 9.67157 9.67157 9 10.5 9C11.3284 9 12 9.67157 12 10.5C12 11.3284 11.3284 12 10.5 12C9.67157 12 9 11.3284 9 10.5Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Cutting-edge Tools",
              desc: "Learn to use popular ML frameworks and libraries that are widely used in the industry."
          },
          {
              id: "5",
              icon: (<svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M9.96424 2.68571C10.0668 2.42931 9.94209 2.13833 9.6857 2.03577C9.4293 1.93322 9.13832 2.05792 9.03576 2.31432L5.03576 12.3143C4.9332 12.5707 5.05791 12.8617 5.3143 12.9642C5.5707 13.0668 5.86168 12.9421 5.96424 12.6857L9.96424 2.68571ZM3.85355 5.14646C4.04882 5.34172 4.04882 5.6583 3.85355 5.85356L2.20711 7.50001L3.85355 9.14646C4.04882 9.34172 4.04882 9.6583 3.85355 9.85356C3.65829 10.0488 3.34171 10.0488 3.14645 9.85356L1.14645 7.85356C0.951184 7.6583 0.951184 7.34172 1.14645 7.14646L3.14645 5.14646C3.34171 4.9512 3.65829 4.9512 3.85355 5.14646ZM11.1464 5.14646C11.3417 4.9512 11.6583 4.9512 11.8536 5.14646L13.8536 7.14646C14.0488 7.34172 14.0488 7.6583 13.8536 7.85356L11.8536 9.85356C11.6583 10.0488 11.3417 10.0488 11.1464 9.85356C10.9512 9.6583 10.9512 9.34172 11.1464 9.14646L12.7929 7.50001L11.1464 5.85356C10.9512 5.6583 10.9512 5.34172 11.1464 5.14646Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "AI Community",
              desc: "Connect with other ML learners and professionals to share knowledge and collaborate."
          },
          {
              id: "6",
              icon: ( <svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M7.28856 0.796908C7.42258 0.734364 7.57742 0.734364 7.71144 0.796908L13.7114 3.59691C13.8875 3.67906 14 3.85574 14 4.05V10.95C14 11.1443 13.8875 11.3209 13.7114 11.4031L7.71144 14.2031C7.57742 14.2656 7.42258 14.2656 7.28856 14.2031L1.28856 11.4031C1.11252 11.3209 1 11.1443 1 10.95V4.05C1 3.85574 1.11252 3.67906 1.28856 3.59691L7.28856 0.796908ZM2 4.80578L7 6.93078V12.9649L2 10.6316V4.80578ZM8 12.9649L13 10.6316V4.80578L8 6.93078V12.9649ZM7.5 6.05672L12.2719 4.02866L7.5 1.80176L2.72809 4.02866L7.5 6.05672Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Advanced Computing Lab",
              desc: "Use our high-performance computers for training complex ML models."
          },
      ]
     
  },
  {
      id: "4",
      title: "What You'll Learn",
      sub_title:"You’ll gain important Machine Learning skills to create smart systems, analyze data for predictions, and solve real-world problems using data-driven methods.",
      Course_img: [
          {
              id: "1",
              img: "https://img.freepik.com/premium-vector/teacher-is-teaching-with-two-students_18660-3089.jpg?w=740",
              title: "Supervised Learning",
              alt: "Supervised Learning"
          },
          {
              id: "2",
              img: "https://img.freepik.com/free-photo/businesspeople-working-finance-accounting-analyze-financi_74952-1411.jpg?t=st=1720783298~exp=1720786898~hmac=2bf341f0769e5dee5809c3bcb974fad2867941ac17f747bcc4f0b7b02c851132&w=740",
              title: "Regression",
              alt: "Regression"
          },
          {
              id: "4",
              img: "https://img.freepik.com/free-photo/businesswoman-networking-using-digital-devices_53876-101875.jpg?t=st=1720783438~exp=1720787038~hmac=456ac7e99f4d61f7e5451dc16837337dbd5150a5d15bf189e3242db2c02a4101&w=740",
              title: "Classification",
            alt: "Classification"
          },
      ]
  },
  {
      id: "5",
      title: "Frequently Asked Questions (FAQs)",
      sub_title: "Still curious about our Machine Learning course? Here are some common questions and answers to help you.",
      faqs: [
         {
          id: "1",
          heading: "Who is this course for?",
          sub_heading: "This course is great for people who have a strong background in math, statistics, and programming. It’s especially good for computer science graduates or those in related fields.",
         },
         {
          id: "2",
          heading: " What programming languages will we use?",
          sub_heading: "We will mainly use Python because it’s very popular in the Machine Learning community. You’ll also learn about R for statistical analysis.",
         },
         {
          id: "3",
          heading: "Is there a final project?",
          sub_heading: "Yes, you’ll complete a capstone project where you will create a complete Machine Learning solution for a real-world problem. This project will be a valuable part of your portfolio.",
         },
         {
          id: "4",
          heading: " Do I need previous experience in Machine Learning?",
          sub_heading: "You don’t need any prior knowledge of Machine Learning, but some programming experience is required. We’ll help you learn from the basics to more advanced topics.",
         },
         {
          id: "5",
          heading: "What job roles can I pursue after this course?",
          sub_heading: "Graduates can become Machine Learning Engineers, Data Scientists, AI Researchers, or ML Ops Engineers, among other roles.",
         },
      ]
  }
]

export const DeepLearning = [

  {
      id: "1",
      small_text: "Start your career as a Deep Learning",
      name: "Deep Learning course in kurukshetra",
      duration_One : "6 Months",
      description: "In today's world of big data and AI, Deep Learning is a powerful technology that is making big changes in many industries. There is a rising need for experts who can create and work with complex neural networks. At BrainboxStudy, we provide in-depth training in Deep Learning. Our aim is to help you develop the advanced skills needed to succeed in this exciting field. Join us and be part of the next wave of AI innovation!",
      image: "/deep.png",
      alt: "Deep Learning",
      join_btn: "Join Now",
  },
  {
      id: "2",
      main_image: "https://img.freepik.com/premium-photo/person-using-ai-tool-job_23-2150711490.jpg?w=740",
      alt: "Deep Learning",
      small_text_one: "Deep Learning Course",
      title: "Deep Learning Course In Kurukshetra: Why Choose This Career?",
      desc: "In today’s fast-changing world of AI, Deep Learning is leading the way by helping machines understand and interact with the world like humans. This career combines advanced math, powerful computing, and creative problem-solving, allowing you to tackle complex challenges in AI. Our Deep Learning Course in Kurukshetra is perfect for those who want to be at the forefront of AI research and applications. Whether you’re a recent graduate with a strong technical background or an experienced professional wanting to focus on AI, Deep Learning offers amazing opportunities. You’ll get to work on exciting projects in areas like computer vision, natural language processing, robotics, and more. As businesses invest more in AI, Deep Learning experts are essential for driving innovation and shaping the future of technology.",
      visit_btn: " Visit the help center"
  },
  {
      id: "3",
      title: "Why Choose BrainboxStudy for Deep Learning?",
      sub_title: "Launch your career in Deep Learning with our advanced, industry-focused course.",
      feature: [
          {
              id: "1",
              icon: ( <svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M0.849976 1.74998C0.849976 1.25292 1.25292 0.849976 1.74998 0.849976H3.24998C3.74703 0.849976 4.14998 1.25292 4.14998 1.74998V2.04998H10.85V1.74998C10.85 1.25292 11.2529 0.849976 11.75 0.849976H13.25C13.747 0.849976 14.15 1.25292 14.15 1.74998V3.24998C14.15 3.74703 13.747 4.14998 13.25 4.14998H12.95V10.85H13.25C13.747 10.85 14.15 11.2529 14.15 11.75V13.25C14.15 13.747 13.747 14.15 13.25 14.15H11.75C11.2529 14.15 10.85 13.747 10.85 13.25V12.95H4.14998V13.25C4.14998 13.747 3.74703 14.15 3.24998 14.15H1.74998C1.25292 14.15 0.849976 13.747 0.849976 13.25V11.75C0.849976 11.2529 1.25292 10.85 1.74998 10.85H2.04998V4.14998H1.74998C1.25292 4.14998 0.849976 3.74703 0.849976 3.24998V1.74998ZM2.94998 4.14998V10.85H3.24998C3.74703 10.85 4.14998 11.2529 4.14998 11.75V12.05H10.85V11.75C10.85 11.2529 11.2529 10.85 11.75 10.85H12.05V4.14998H11.75C11.2529 4.14998 10.85 3.74703 10.85 3.24998V2.94998H4.14998V3.24998C4.14998 3.74703 3.74703 4.14998 3.24998 4.14998H2.94998ZM2.34998 1.74998H1.74998V2.34998V2.64998V3.24998H2.34998H2.64998H3.24998V2.64998V2.34998V1.74998H2.64998H2.34998ZM5.09998 5.99998C5.09998 5.50292 5.50292 5.09998 5.99998 5.09998H6.99998C7.49703 5.09998 7.89998 5.50292 7.89998 5.99998V6.99998C7.89998 7.03591 7.89787 7.07134 7.89378 7.10618C7.92861 7.10208 7.96405 7.09998 7.99998 7.09998H8.99998C9.49703 7.09998 9.89998 7.50292 9.89998 7.99998V8.99998C9.89998 9.49703 9.49703 9.89998 8.99998 9.89998H7.99998C7.50292 9.89998 7.09998 9.49703 7.09998 8.99998V7.99998C7.09998 7.96405 7.10208 7.92861 7.10618 7.89378C7.07134 7.89787 7.03591 7.89998 6.99998 7.89998H5.99998C5.50292 7.89998 5.09998 7.49703 5.09998 6.99998V5.99998ZM6.09998 5.99998H5.99998V6.09998V6.89998V6.99998H6.09998H6.89998H6.99998V6.89998V6.09998V5.99998H6.89998H6.09998ZM7.99998 7.99998H8.09998H8.89998H8.99998V8.09998V8.89998V8.99998H8.89998H8.09998H7.99998V8.89998V8.09998V7.99998ZM2.64998 11.75H2.34998H1.74998V12.35V12.65V13.25H2.34998H2.64998H3.24998V12.65V12.35V11.75H2.64998ZM11.75 1.74998H12.35H12.65H13.25V2.34998V2.64998V3.24998H12.65H12.35H11.75V2.64998V2.34998V1.74998ZM12.65 11.75H12.35H11.75V12.35V12.65V13.25H12.35H12.65H13.25V12.65V12.35V11.75H12.65Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Expert Faculty",
              desc: "Learn from top AI researchers and practitioners who are leading advancements in Deep Learning."
          },
          {
              id: "2",
              icon: ( <svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M3.00014 2.73895C3.00014 2.94698 2.76087 3.06401 2.59666 2.93628L1.00386 1.69744C0.875177 1.59735 0.875177 1.40286 1.00386 1.30277L2.59666 0.063928C2.76087 -0.0637944 3.00014 0.0532293 3.00014 0.261266V1.00012H9.00009V0.261296C9.00009 0.0532591 9.23936 -0.0637646 9.40358 0.0639578L10.9964 1.3028C11.1251 1.40289 11.1251 1.59738 10.9964 1.69747L9.40358 2.93631C9.23936 3.06404 9.00009 2.94701 9.00009 2.73898V2.00012H3.00014V2.73895ZM9.50002 4.99998H2.50002C2.22388 4.99998 2.00002 5.22384 2.00002 5.49998V12.5C2.00002 12.7761 2.22388 13 2.50002 13H9.50002C9.77616 13 10 12.7761 10 12.5V5.49998C10 5.22384 9.77616 4.99998 9.50002 4.99998ZM2.50002 3.99998C1.67159 3.99998 1.00002 4.67156 1.00002 5.49998V12.5C1.00002 13.3284 1.67159 14 2.50002 14H9.50002C10.3284 14 11 13.3284 11 12.5V5.49998C11 4.67156 10.3284 3.99998 9.50002 3.99998H2.50002ZM14.7389 6.00001H14V12H14.7389C14.9469 12 15.064 12.2393 14.9362 12.4035L13.6974 13.9963C13.5973 14.125 13.4028 14.125 13.3027 13.9963L12.0639 12.4035C11.9362 12.2393 12.0532 12 12.2612 12H13V6.00001H12.2612C12.0532 6.00001 11.9361 5.76074 12.0639 5.59653L13.3027 4.00373C13.4028 3.87505 13.5973 3.87505 13.6974 4.00374L14.9362 5.59653C15.0639 5.76074 14.9469 6.00001 14.7389 6.00001Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Cutting-Edge Curriculum",
              desc: "Master the latest techniques and models used in both industry and research."
          },
          {
              id: "3",
              icon: (<svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M1 2C0.447715 2 0 2.44772 0 3V12C0 12.5523 0.447715 13 1 13H14C14.5523 13 15 12.5523 15 12V3C15 2.44772 14.5523 2 14 2H1ZM1 3L14 3V3.92494C13.9174 3.92486 13.8338 3.94751 13.7589 3.99505L7.5 7.96703L1.24112 3.99505C1.16621 3.94751 1.0826 3.92486 1 3.92494V3ZM1 4.90797V12H14V4.90797L7.74112 8.87995C7.59394 8.97335 7.40606 8.97335 7.25888 8.87995L1 4.90797Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Hands-On Projects",
              desc: "Build a strong portfolio with projects in areas like computer vision, natural language processing, and reinforcement learning."
          },
          {
              id: "4",
              icon: ( <svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M4.5 2C3.11929 2 2 3.11929 2 4.5C2 5.88072 3.11929 7 4.5 7C5.88072 7 7 5.88072 7 4.5C7 3.11929 5.88072 2 4.5 2ZM3 4.5C3 3.67157 3.67157 3 4.5 3C5.32843 3 6 3.67157 6 4.5C6 5.32843 5.32843 6 4.5 6C3.67157 6 3 5.32843 3 4.5ZM10.5 2C9.11929 2 8 3.11929 8 4.5C8 5.88072 9.11929 7 10.5 7C11.8807 7 13 5.88072 13 4.5C13 3.11929 11.8807 2 10.5 2ZM9 4.5C9 3.67157 9.67157 3 10.5 3C11.3284 3 12 3.67157 12 4.5C12 5.32843 11.3284 6 10.5 6C9.67157 6 9 5.32843 9 4.5ZM2 10.5C2 9.11929 3.11929 8 4.5 8C5.88072 8 7 9.11929 7 10.5C7 11.8807 5.88072 13 4.5 13C3.11929 13 2 11.8807 2 10.5ZM4.5 9C3.67157 9 3 9.67157 3 10.5C3 11.3284 3.67157 12 4.5 12C5.32843 12 6 11.3284 6 10.5C6 9.67157 5.32843 9 4.5 9ZM10.5 8C9.11929 8 8 9.11929 8 10.5C8 11.8807 9.11929 13 10.5 13C11.8807 13 13 11.8807 13 10.5C13 9.11929 11.8807 8 10.5 8ZM9 10.5C9 9.67157 9.67157 9 10.5 9C11.3284 9 12 9.67157 12 10.5C12 11.3284 11.3284 12 10.5 12C9.67157 12 9 11.3284 9 10.5Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Career Support",
              desc: "Receive guidance on job placements, research opportunities, and connections with AI companies."
          },
          {
              id: "5",
              icon: (<svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M9.96424 2.68571C10.0668 2.42931 9.94209 2.13833 9.6857 2.03577C9.4293 1.93322 9.13832 2.05792 9.03576 2.31432L5.03576 12.3143C4.9332 12.5707 5.05791 12.8617 5.3143 12.9642C5.5707 13.0668 5.86168 12.9421 5.96424 12.6857L9.96424 2.68571ZM3.85355 5.14646C4.04882 5.34172 4.04882 5.6583 3.85355 5.85356L2.20711 7.50001L3.85355 9.14646C4.04882 9.34172 4.04882 9.6583 3.85355 9.85356C3.65829 10.0488 3.34171 10.0488 3.14645 9.85356L1.14645 7.85356C0.951184 7.6583 0.951184 7.34172 1.14645 7.14646L3.14645 5.14646C3.34171 4.9512 3.65829 4.9512 3.85355 5.14646ZM11.1464 5.14646C11.3417 4.9512 11.6583 4.9512 11.8536 5.14646L13.8536 7.14646C14.0488 7.34172 14.0488 7.6583 13.8536 7.85356L11.8536 9.85356C11.6583 10.0488 11.3417 10.0488 11.1464 9.85356C10.9512 9.6583 10.9512 9.34172 11.1464 9.14646L12.7929 7.50001L11.1464 5.85356C10.9512 5.6583 10.9512 5.34172 11.1464 5.14646Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "AI Community",
              desc: "Join a network of AI enthusiasts, researchers, and professionals for collaboration and support."
          },
          {
              id: "6",
              icon: ( <svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M7.28856 0.796908C7.42258 0.734364 7.57742 0.734364 7.71144 0.796908L13.7114 3.59691C13.8875 3.67906 14 3.85574 14 4.05V10.95C14 11.1443 13.8875 11.3209 13.7114 11.4031L7.71144 14.2031C7.57742 14.2656 7.42258 14.2656 7.28856 14.2031L1.28856 11.4031C1.11252 11.3209 1 11.1443 1 10.95V4.05C1 3.85574 1.11252 3.67906 1.28856 3.59691L7.28856 0.796908ZM2 4.80578L7 6.93078V12.9649L2 10.6316V4.80578ZM8 12.9649L13 10.6316V4.80578L8 6.93078V12.9649ZM7.5 6.05672L12.2719 4.02866L7.5 1.80176L2.72809 4.02866L7.5 6.05672Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Advanced AI Lab",
              desc: "Access powerful GPUs and cloud resources to train complex neural networks."
          },
      ]
     
  },
  {
      id: "4",
      title: "What You'll Learn",
      sub_title:"Develop skills in designing, training, and optimizing deep neural networks for a range of applications, including image recognition and natural language understanding.",
      Course_img: [
          {
              id: "1",
              img: "https://img.freepik.com/free-vector/gradient-network-connection-background_23-2148870461.jpg?t=st=1720783610~exp=1720787210~hmac=a574635bce1ee4b51f0b2208b61ac8a879cebcdfe50b53f493cffcca42ea18c1&w=740",
              title: "Artificial Neural Network",
              alt: "Artificial"
          },
          {
              id: "2",
              img: "https://img.freepik.com/free-photo/middle-eastern-cybersecurity-professional_482257-76195.jpg?t=st=1720783667~exp=1720787267~hmac=0b221b08bb5f25dcd562e1fcba8f77d3ffa83ffb210a6394d5a0284321d5d19d&w=740",
              title: "Natural Language Processing",
              alt: "Natural Language"
          },
          {
              id: "4",
              img: "https://img.freepik.com/free-vector/teamwork-man-with-computer-puzzle-pieces_24877-54948.jpg?t=st=1720783797~exp=1720787397~hmac=27d9d929d890d87cc7311ad6ddfd31def84f1557a47d71be8b1f43d2e192aaa2&w=740",
              title: "Image Processing",
              alt: "Image Processing"
          },
      ]
  },
  {
      id: "5",
      title: "Frequently Asked Questions (FAQs)",
      sub_title: "Have more questions about our Deep Learning course? Here are answers to some common ones.",
      faqs: [
         {
          id: "1",
          heading: "What prerequisites are required for this course?",
          sub_heading: "You need strong programming skills (especially in Python) and a good understanding of linear algebra, calculus, and probability. Previous experience with Machine Learning is highly recommended.",
         },
         {
          id: "2",
          heading: " Which Deep Learning frameworks will be covered?",
          sub_heading: "We will focus on TensorFlow and PyTorch, the two most popular frameworks in both industry and research. You'll also learn about other useful libraries and tools.",
         },
         {
          id: "3",
          heading: "Is there a research component to this course?",
          sub_heading: "Yes! You’ll have the chance to explore current research papers, implement advanced models, and possibly contribute to ongoing research projects.",
         },
         {
          id: "4",
          heading: " Can this course prepare me for a Ph.D. in AI?",
          sub_heading: "Absolutely! The course covers advanced topics and research methods that will give you a strong foundation for doctoral studies in AI and Deep Learning.",
         },
         {
          id: "5",
          heading: "What kind of projects will I work on?",
          sub_heading: "You’ll work on a variety of projects, including image classification, object detection, sentiment analysis, language translation, and even generative models like GANs.",
         },
      ]
  }
]

export const ArtificialIntelligence = [
  {
      id: "1",
      small_text: "Start your career as a Artificial Intelligence",
      name: "Artificial Intelligence course in kurukshetra",
      duration_One : "8 Months",
      description: "In today's fast-changing tech world, Artificial Intelligence (AI) is changing industries and how we live. There is a growing need for skilled professionals who can create smart systems that can think, learn, and adapt. At BrainboxStudy, we provide complete training in AI. Our goal is to help you gain the advanced skills needed to lead in this exciting field. Join us and help shape the future of technology!",
      image: "/Aidemo.png",
      alt: "Ai",
      join_btn: "Join Now",
  },
  {
      id: "2",
      main_image: "https://img.freepik.com/premium-photo/future-artificial-intelligence-robot-cyborg_31965-16596.jpg?w=740",
      alt: "Artificial Intelligence",
      small_text_one: "Artificial Intelligence Course",
      title: "Artificial Intelligence Course in Kurukshetra: Why Choose This Career?",
      desc: "In today’s digital world, AI is leading innovation in many industries. This career combines computer science, math, and cognitive science, letting you create systems that can think, reason, and act. Our AI Course in Kurukshetra is ideal for those who want to be at the forefront of technology and solve important global challenges.Whether you're a recent graduate with a strong tech background or a professional wanting to switch to AI, this field offers endless opportunities. You can work on exciting technologies like self-driving systems, smart assistants, and predictive analytics. As companies increasingly use AI to improve efficiency and drive innovation, AI specialists are vital in shaping the future of technology and society.",
      visit_btn: " Visit the help center"
  },
  {
      id: "3",
      title: "Why Choose BrainboxStudy for Artificial Intelligence?",
      sub_title: "Start your journey to becoming an AI expert with our comprehensive and industry-focused course.",
      feature: [
          {
              id: "1",
              icon: ( <svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M0.849976 1.74998C0.849976 1.25292 1.25292 0.849976 1.74998 0.849976H3.24998C3.74703 0.849976 4.14998 1.25292 4.14998 1.74998V2.04998H10.85V1.74998C10.85 1.25292 11.2529 0.849976 11.75 0.849976H13.25C13.747 0.849976 14.15 1.25292 14.15 1.74998V3.24998C14.15 3.74703 13.747 4.14998 13.25 4.14998H12.95V10.85H13.25C13.747 10.85 14.15 11.2529 14.15 11.75V13.25C14.15 13.747 13.747 14.15 13.25 14.15H11.75C11.2529 14.15 10.85 13.747 10.85 13.25V12.95H4.14998V13.25C4.14998 13.747 3.74703 14.15 3.24998 14.15H1.74998C1.25292 14.15 0.849976 13.747 0.849976 13.25V11.75C0.849976 11.2529 1.25292 10.85 1.74998 10.85H2.04998V4.14998H1.74998C1.25292 4.14998 0.849976 3.74703 0.849976 3.24998V1.74998ZM2.94998 4.14998V10.85H3.24998C3.74703 10.85 4.14998 11.2529 4.14998 11.75V12.05H10.85V11.75C10.85 11.2529 11.2529 10.85 11.75 10.85H12.05V4.14998H11.75C11.2529 4.14998 10.85 3.74703 10.85 3.24998V2.94998H4.14998V3.24998C4.14998 3.74703 3.74703 4.14998 3.24998 4.14998H2.94998ZM2.34998 1.74998H1.74998V2.34998V2.64998V3.24998H2.34998H2.64998H3.24998V2.64998V2.34998V1.74998H2.64998H2.34998ZM5.09998 5.99998C5.09998 5.50292 5.50292 5.09998 5.99998 5.09998H6.99998C7.49703 5.09998 7.89998 5.50292 7.89998 5.99998V6.99998C7.89998 7.03591 7.89787 7.07134 7.89378 7.10618C7.92861 7.10208 7.96405 7.09998 7.99998 7.09998H8.99998C9.49703 7.09998 9.89998 7.50292 9.89998 7.99998V8.99998C9.89998 9.49703 9.49703 9.89998 8.99998 9.89998H7.99998C7.50292 9.89998 7.09998 9.49703 7.09998 8.99998V7.99998C7.09998 7.96405 7.10208 7.92861 7.10618 7.89378C7.07134 7.89787 7.03591 7.89998 6.99998 7.89998H5.99998C5.50292 7.89998 5.09998 7.49703 5.09998 6.99998V5.99998ZM6.09998 5.99998H5.99998V6.09998V6.89998V6.99998H6.09998H6.89998H6.99998V6.89998V6.09998V5.99998H6.89998H6.09998ZM7.99998 7.99998H8.09998H8.89998H8.99998V8.09998V8.89998V8.99998H8.89998H8.09998H7.99998V8.89998V8.09998V7.99998ZM2.64998 11.75H2.34998H1.74998V12.35V12.65V13.25H2.34998H2.64998H3.24998V12.65V12.35V11.75H2.64998ZM11.75 1.74998H12.35H12.65H13.25V2.34998V2.64998V3.24998H12.65H12.35H11.75V2.64998V2.34998V1.74998ZM12.65 11.75H12.35H11.75V12.35V12.65V13.25H12.35H12.65H13.25V12.65V12.35V11.75H12.65Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Top AI Experts",
              desc: "Learn from leading researchers and professionals in the field of AI."
          },
          {
              id: "2",
              icon: ( <svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M3.00014 2.73895C3.00014 2.94698 2.76087 3.06401 2.59666 2.93628L1.00386 1.69744C0.875177 1.59735 0.875177 1.40286 1.00386 1.30277L2.59666 0.063928C2.76087 -0.0637944 3.00014 0.0532293 3.00014 0.261266V1.00012H9.00009V0.261296C9.00009 0.0532591 9.23936 -0.0637646 9.40358 0.0639578L10.9964 1.3028C11.1251 1.40289 11.1251 1.59738 10.9964 1.69747L9.40358 2.93631C9.23936 3.06404 9.00009 2.94701 9.00009 2.73898V2.00012H3.00014V2.73895ZM9.50002 4.99998H2.50002C2.22388 4.99998 2.00002 5.22384 2.00002 5.49998V12.5C2.00002 12.7761 2.22388 13 2.50002 13H9.50002C9.77616 13 10 12.7761 10 12.5V5.49998C10 5.22384 9.77616 4.99998 9.50002 4.99998ZM2.50002 3.99998C1.67159 3.99998 1.00002 4.67156 1.00002 5.49998V12.5C1.00002 13.3284 1.67159 14 2.50002 14H9.50002C10.3284 14 11 13.3284 11 12.5V5.49998C11 4.67156 10.3284 3.99998 9.50002 3.99998H2.50002ZM14.7389 6.00001H14V12H14.7389C14.9469 12 15.064 12.2393 14.9362 12.4035L13.6974 13.9963C13.5973 14.125 13.4028 14.125 13.3027 13.9963L12.0639 12.4035C11.9362 12.2393 12.0532 12 12.2612 12H13V6.00001H12.2612C12.0532 6.00001 11.9361 5.76074 12.0639 5.59653L13.3027 4.00373C13.4028 3.87505 13.5973 3.87505 13.6974 4.00374L14.9362 5.59653C15.0639 5.76074 14.9469 6.00001 14.7389 6.00001Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Complete Curriculum",
              desc: " Explore various AI areas, including machine learning, natural language processing, computer vision, and robotics."
          },
          {
              id: "3",
              icon: (<svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M1 2C0.447715 2 0 2.44772 0 3V12C0 12.5523 0.447715 13 1 13H14C14.5523 13 15 12.5523 15 12V3C15 2.44772 14.5523 2 14 2H1ZM1 3L14 3V3.92494C13.9174 3.92486 13.8338 3.94751 13.7589 3.99505L7.5 7.96703L1.24112 3.99505C1.16621 3.94751 1.0826 3.92486 1 3.92494V3ZM1 4.90797V12H14V4.90797L7.74112 8.87995C7.59394 8.97335 7.40606 8.97335 7.25888 8.87995L1 4.90797Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Real-World Projects",
              desc: "Build a strong portfolio by working on projects that tackle actual industry challenges using AI."
          },
          {
              id: "4",
              icon: ( <svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M4.5 2C3.11929 2 2 3.11929 2 4.5C2 5.88072 3.11929 7 4.5 7C5.88072 7 7 5.88072 7 4.5C7 3.11929 5.88072 2 4.5 2ZM3 4.5C3 3.67157 3.67157 3 4.5 3C5.32843 3 6 3.67157 6 4.5C6 5.32843 5.32843 6 4.5 6C3.67157 6 3 5.32843 3 4.5ZM10.5 2C9.11929 2 8 3.11929 8 4.5C8 5.88072 9.11929 7 10.5 7C11.8807 7 13 5.88072 13 4.5C13 3.11929 11.8807 2 10.5 2ZM9 4.5C9 3.67157 9.67157 3 10.5 3C11.3284 3 12 3.67157 12 4.5C12 5.32843 11.3284 6 10.5 6C9.67157 6 9 5.32843 9 4.5ZM2 10.5C2 9.11929 3.11929 8 4.5 8C5.88072 8 7 9.11929 7 10.5C7 11.8807 5.88072 13 4.5 13C3.11929 13 2 11.8807 2 10.5ZM4.5 9C3.67157 9 3 9.67157 3 10.5C3 11.3284 3.67157 12 4.5 12C5.32843 12 6 11.3284 6 10.5C6 9.67157 5.32843 9 4.5 9ZM10.5 8C9.11929 8 8 9.11929 8 10.5C8 11.8807 9.11929 13 10.5 13C11.8807 13 13 11.8807 13 10.5C13 9.11929 11.8807 8 10.5 8ZM9 10.5C9 9.67157 9.67157 9 10.5 9C11.3284 9 12 9.67157 12 10.5C12 11.3284 11.3284 12 10.5 12C9.67157 12 9 11.3284 9 10.5Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Career Support",
              desc: " Get help with research opportunities, job placements, and connections to AI-focused companies."
          },
          {
              id: "5",
              icon: (<svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M9.96424 2.68571C10.0668 2.42931 9.94209 2.13833 9.6857 2.03577C9.4293 1.93322 9.13832 2.05792 9.03576 2.31432L5.03576 12.3143C4.9332 12.5707 5.05791 12.8617 5.3143 12.9642C5.5707 13.0668 5.86168 12.9421 5.96424 12.6857L9.96424 2.68571ZM3.85355 5.14646C4.04882 5.34172 4.04882 5.6583 3.85355 5.85356L2.20711 7.50001L3.85355 9.14646C4.04882 9.34172 4.04882 9.6583 3.85355 9.85356C3.65829 10.0488 3.34171 10.0488 3.14645 9.85356L1.14645 7.85356C0.951184 7.6583 0.951184 7.34172 1.14645 7.14646L3.14645 5.14646C3.34171 4.9512 3.65829 4.9512 3.85355 5.14646ZM11.1464 5.14646C11.3417 4.9512 11.6583 4.9512 11.8536 5.14646L13.8536 7.14646C14.0488 7.34172 14.0488 7.6583 13.8536 7.85356L11.8536 9.85356C11.6583 10.0488 11.3417 10.0488 11.1464 9.85356C10.9512 9.6583 10.9512 9.34172 11.1464 9.14646L12.7929 7.50001L11.1464 5.85356C10.9512 5.6583 10.9512 5.34172 11.1464 5.14646Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "AI Community",
              desc: " Join a lively network of AI enthusiasts, researchers, and industry experts."
          },
          {
              id: "6",
              icon: ( <svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                >
                  <path
                    d="M7.28856 0.796908C7.42258 0.734364 7.57742 0.734364 7.71144 0.796908L13.7114 3.59691C13.8875 3.67906 14 3.85574 14 4.05V10.95C14 11.1443 13.8875 11.3209 13.7114 11.4031L7.71144 14.2031C7.57742 14.2656 7.42258 14.2656 7.28856 14.2031L1.28856 11.4031C1.11252 11.3209 1 11.1443 1 10.95V4.05C1 3.85574 1.11252 3.67906 1.28856 3.59691L7.28856 0.796908ZM2 4.80578L7 6.93078V12.9649L2 10.6316V4.80578ZM8 12.9649L13 10.6316V4.80578L8 6.93078V12.9649ZM7.5 6.05672L12.2719 4.02866L7.5 1.80176L2.72809 4.02866L7.5 6.05672Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>),
              title: "Advanced AI Lab",
              desc: "Access the latest computing resources and AI tools to enhance your learning experience."
          },
      ]
     
  },
  {
      id: "4",
      title: "What You'll Learn",
      sub_title:"You will master both basic and advanced AI concepts, including search algorithms, knowledge representation, machine learning, and deep neural networks.",
      Course_img: [
          {
              id: "1",
              img: "https://www.eu-startups.com/wp-content/uploads/2023/09/PANDA-AI-min.png",
              title: "Pandas",
              alt: "Pandas"
          },
          {
              id: "2",
              img: "https://img.freepik.com/free-photo/programming-background-with-person-working-with-codes-computer_23-2150010125.jpg?t=st=1720782587~exp=1720786187~hmac=76a7b31846747282614cedbb1ef66a3b8f51506ec9362478acfd553bde6bd1ec&w=740",
              title: "NumPy",
              alt: "NumPy"
          },
          {
              id: "4",
              img: "https://img.freepik.com/free-vector/people-analyzing-growth-charts_23-2148866843.jpg?t=st=1720782146~exp=1720785746~hmac=d15f319676103446697df855faf0d113c61ca42814e2a8954929127340e68587&w=740",
              title: "Data Science",
              alt: "Data Science"
          },
      ]
  },
  {
      id: "5",
      title: "Frequently Asked Questions (FAQs)",
      sub_title: "Still have questions about our AI course? Here are some common answers to help you. Here are some common ones.",
      faqs: [
         {
          id: "1",
          heading: "What background do I need for this course?",
          sub_heading: "You should have a good understanding of programming, mathematics (especially linear algebra, calculus, and probability), and basic algorithms. Prior experience with machine learning is helpful but not required.",
         },
         {
          id: "2",
          heading: "What programming languages will be used?",
          sub_heading: "The course mainly uses Python because it’s popular in AI development. We’ll also introduce you to special AI libraries and frameworks.",
         },
         {
          id: "3",
          heading: "Does the course cover ethical considerations in AI?",
          sub_heading: "Yes, we include modules on AI ethics, discussing topics like bias in AI, privacy issues, and the impact of AI on society.",
         },
         {
          id: "4",
          heading: "Are there opportunities for specialization within the course?",
          sub_heading: "Absolutely! In the later stages of the course, you can choose to focus on areas like computer vision, natural language processing, or reinforcement learning based on your interests.",
         },
         {
          id: "5",
          heading: "What career paths can I pursue after this course?",
          sub_heading: "Graduates can pursue roles such as AI Engineer, Machine Learning Scientist, AI Researcher, Data Scientist, or AI Product Manager, among others.",
         },
         {
          id: "6",
          heading: "Is there a capstone project?",
          sub_heading: "Yes, you will complete a capstone project where you develop a complete AI solution, demonstrating your ability to apply AI techniques to real-world problems.",
         },
      ]
  }
]


export const EthicalHacker = [
    {
        id: "1",
        small_text: "Start your career as a Certified Ethical Hacker",
        name: "Certified Ethical Hacker course in kurukshetra",
        duration_One : "2 Years",
        description: "In today’s cybersecurity world, companies need skilled experts who can think like hackers to protect against them. There is a rising demand for Certified Ethical Hackers who can find weaknesses and improve security systems. At BrainboxStudy, we provide complete training for the well-respected CEH certification. Our aim is to give you the skills you need to succeed in the important field of information security. Join us and become a protector of the digital world!",
        image: "/Ceh.png",
        join_btn: "Join Now",
         alt: "Ceh"
    },
    {
        id: "2",
        main_image: "https://img.freepik.com/free-photo/close-up-hacker-holding-laptop_23-2149101210.jpg?t=st=1720784886~exp=1720788486~hmac=2ae03a7c0403d437ceec98fa1aad12d7e1ead1344cc0077f816341f1f76263cc&w=740",
        small_text_one: "Certified Ethical Hacker Course",
        title: "Certified Ethical Hacker Course in Kurukshetra: Why Choose This Career?",
        desc: "n our connected world, cybersecurity is more important than ever for businesses and governments. This career combines technical skills with creative problem-solving, helping you stay ahead of cybercriminals. Our CEH Certification Course in Kurukshetra is perfect for IT professionals who want to specialize in cybersecurity and for anyone passionate about protecting digital assets.Whether you're an IT expert wanting to improve your skills or a security enthusiast starting a career in cybersecurity, ethical hacking offers exciting opportunities. You'll work in various industries, continually learn in this fast-changing field, and make a real impact on security. As cyber threats become more advanced, Certified Ethical Hackers are essential for protecting sensitive information and critical systems.",
        visit_btn: " Visit the help center"
    },
    {
        id: "3",
        title: "Why Choose BrainboxStudy for CEH Certification?",
        sub_title: "Get ready for your CEH certification with our hands-on training program designed for the industry.",
        feature: [
            {
                id: "1",
                icon: ( <svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M0.849976 1.74998C0.849976 1.25292 1.25292 0.849976 1.74998 0.849976H3.24998C3.74703 0.849976 4.14998 1.25292 4.14998 1.74998V2.04998H10.85V1.74998C10.85 1.25292 11.2529 0.849976 11.75 0.849976H13.25C13.747 0.849976 14.15 1.25292 14.15 1.74998V3.24998C14.15 3.74703 13.747 4.14998 13.25 4.14998H12.95V10.85H13.25C13.747 10.85 14.15 11.2529 14.15 11.75V13.25C14.15 13.747 13.747 14.15 13.25 14.15H11.75C11.2529 14.15 10.85 13.747 10.85 13.25V12.95H4.14998V13.25C4.14998 13.747 3.74703 14.15 3.24998 14.15H1.74998C1.25292 14.15 0.849976 13.747 0.849976 13.25V11.75C0.849976 11.2529 1.25292 10.85 1.74998 10.85H2.04998V4.14998H1.74998C1.25292 4.14998 0.849976 3.74703 0.849976 3.24998V1.74998ZM2.94998 4.14998V10.85H3.24998C3.74703 10.85 4.14998 11.2529 4.14998 11.75V12.05H10.85V11.75C10.85 11.2529 11.2529 10.85 11.75 10.85H12.05V4.14998H11.75C11.2529 4.14998 10.85 3.74703 10.85 3.24998V2.94998H4.14998V3.24998C4.14998 3.74703 3.74703 4.14998 3.24998 4.14998H2.94998ZM2.34998 1.74998H1.74998V2.34998V2.64998V3.24998H2.34998H2.64998H3.24998V2.64998V2.34998V1.74998H2.64998H2.34998ZM5.09998 5.99998C5.09998 5.50292 5.50292 5.09998 5.99998 5.09998H6.99998C7.49703 5.09998 7.89998 5.50292 7.89998 5.99998V6.99998C7.89998 7.03591 7.89787 7.07134 7.89378 7.10618C7.92861 7.10208 7.96405 7.09998 7.99998 7.09998H8.99998C9.49703 7.09998 9.89998 7.50292 9.89998 7.99998V8.99998C9.89998 9.49703 9.49703 9.89998 8.99998 9.89998H7.99998C7.50292 9.89998 7.09998 9.49703 7.09998 8.99998V7.99998C7.09998 7.96405 7.10208 7.92861 7.10618 7.89378C7.07134 7.89787 7.03591 7.89998 6.99998 7.89998H5.99998C5.50292 7.89998 5.09998 7.49703 5.09998 6.99998V5.99998ZM6.09998 5.99998H5.99998V6.09998V6.89998V6.99998H6.09998H6.89998H6.99998V6.89998V6.09998V5.99998H6.89998H6.09998ZM7.99998 7.99998H8.09998H8.89998H8.99998V8.09998V8.89998V8.99998H8.89998H8.09998H7.99998V8.89998V8.09998V7.99998ZM2.64998 11.75H2.34998H1.74998V12.35V12.65V13.25H2.34998H2.64998H3.24998V12.65V12.35V11.75H2.64998ZM11.75 1.74998H12.35H12.65H13.25V2.34998V2.64998V3.24998H12.65H12.35H11.75V2.64998V2.34998V1.74998ZM12.65 11.75H12.35H11.75V12.35V12.65V13.25H12.35H12.65H13.25V12.65V12.35V11.75H12.65Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Experienced Instructors",
                desc: "Learn from certified ethical hackers who have real-world experience in penetration testing."
            },
            {
                id: "2",
                icon: ( <svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M3.00014 2.73895C3.00014 2.94698 2.76087 3.06401 2.59666 2.93628L1.00386 1.69744C0.875177 1.59735 0.875177 1.40286 1.00386 1.30277L2.59666 0.063928C2.76087 -0.0637944 3.00014 0.0532293 3.00014 0.261266V1.00012H9.00009V0.261296C9.00009 0.0532591 9.23936 -0.0637646 9.40358 0.0639578L10.9964 1.3028C11.1251 1.40289 11.1251 1.59738 10.9964 1.69747L9.40358 2.93631C9.23936 3.06404 9.00009 2.94701 9.00009 2.73898V2.00012H3.00014V2.73895ZM9.50002 4.99998H2.50002C2.22388 4.99998 2.00002 5.22384 2.00002 5.49998V12.5C2.00002 12.7761 2.22388 13 2.50002 13H9.50002C9.77616 13 10 12.7761 10 12.5V5.49998C10 5.22384 9.77616 4.99998 9.50002 4.99998ZM2.50002 3.99998C1.67159 3.99998 1.00002 4.67156 1.00002 5.49998V12.5C1.00002 13.3284 1.67159 14 2.50002 14H9.50002C10.3284 14 11 13.3284 11 12.5V5.49998C11 4.67156 10.3284 3.99998 9.50002 3.99998H2.50002ZM14.7389 6.00001H14V12H14.7389C14.9469 12 15.064 12.2393 14.9362 12.4035L13.6974 13.9963C13.5973 14.125 13.4028 14.125 13.3027 13.9963L12.0639 12.4035C11.9362 12.2393 12.0532 12 12.2612 12H13V6.00001H12.2612C12.0532 6.00001 11.9361 5.76074 12.0639 5.59653L13.3027 4.00373C13.4028 3.87505 13.5973 3.87505 13.6974 4.00374L14.9362 5.59653C15.0639 5.76074 14.9469 6.00001 14.7389 6.00001Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Practical Approach",
                desc: " Gain hands-on skills in our advanced hacking lab with real-life scenarios."
            },
            {
                id: "3",
                icon: (<svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M1 2C0.447715 2 0 2.44772 0 3V12C0 12.5523 0.447715 13 1 13H14C14.5523 13 15 12.5523 15 12V3C15 2.44772 14.5523 2 14 2H1ZM1 3L14 3V3.92494C13.9174 3.92486 13.8338 3.94751 13.7589 3.99505L7.5 7.96703L1.24112 3.99505C1.16621 3.94751 1.0826 3.92486 1 3.92494V3ZM1 4.90797V12H14V4.90797L7.74112 8.87995C7.59394 8.97335 7.40606 8.97335 7.25888 8.87995L1 4.90797Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Exam Preparation",
                desc: "Access comprehensive study materials and practice tests that match the latest CEH exam requirements."
            },
            {
                id: "4",
                icon: ( <svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M4.5 2C3.11929 2 2 3.11929 2 4.5C2 5.88072 3.11929 7 4.5 7C5.88072 7 7 5.88072 7 4.5C7 3.11929 5.88072 2 4.5 2ZM3 4.5C3 3.67157 3.67157 3 4.5 3C5.32843 3 6 3.67157 6 4.5C6 5.32843 5.32843 6 4.5 6C3.67157 6 3 5.32843 3 4.5ZM10.5 2C9.11929 2 8 3.11929 8 4.5C8 5.88072 9.11929 7 10.5 7C11.8807 7 13 5.88072 13 4.5C13 3.11929 11.8807 2 10.5 2ZM9 4.5C9 3.67157 9.67157 3 10.5 3C11.3284 3 12 3.67157 12 4.5C12 5.32843 11.3284 6 10.5 6C9.67157 6 9 5.32843 9 4.5ZM2 10.5C2 9.11929 3.11929 8 4.5 8C5.88072 8 7 9.11929 7 10.5C7 11.8807 5.88072 13 4.5 13C3.11929 13 2 11.8807 2 10.5ZM4.5 9C3.67157 9 3 9.67157 3 10.5C3 11.3284 3.67157 12 4.5 12C5.32843 12 6 11.3284 6 10.5C6 9.67157 5.32843 9 4.5 9ZM10.5 8C9.11929 8 8 9.11929 8 10.5C8 11.8807 9.11929 13 10.5 13C11.8807 13 13 11.8807 13 10.5C13 9.11929 11.8807 8 10.5 8ZM9 10.5C9 9.67157 9.67157 9 10.5 9C11.3284 9 12 9.67157 12 10.5C12 11.3284 11.3284 12 10.5 12C9.67157 12 9 11.3284 9 10.5Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Career Support",
                desc: "Benefit from job placement assistance, resume building, and networking opportunities in the cybersecurity field."
            },
            {
                id: "5",
                icon: (<svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M9.96424 2.68571C10.0668 2.42931 9.94209 2.13833 9.6857 2.03577C9.4293 1.93322 9.13832 2.05792 9.03576 2.31432L5.03576 12.3143C4.9332 12.5707 5.05791 12.8617 5.3143 12.9642C5.5707 13.0668 5.86168 12.9421 5.96424 12.6857L9.96424 2.68571ZM3.85355 5.14646C4.04882 5.34172 4.04882 5.6583 3.85355 5.85356L2.20711 7.50001L3.85355 9.14646C4.04882 9.34172 4.04882 9.6583 3.85355 9.85356C3.65829 10.0488 3.34171 10.0488 3.14645 9.85356L1.14645 7.85356C0.951184 7.6583 0.951184 7.34172 1.14645 7.14646L3.14645 5.14646C3.34171 4.9512 3.65829 4.9512 3.85355 5.14646ZM11.1464 5.14646C11.3417 4.9512 11.6583 4.9512 11.8536 5.14646L13.8536 7.14646C14.0488 7.34172 14.0488 7.6583 13.8536 7.85356L11.8536 9.85356C11.6583 10.0488 11.3417 10.0488 11.1464 9.85356C10.9512 9.6583 10.9512 9.34172 11.1464 9.14646L12.7929 7.50001L11.1464 5.85356C10.9512 5.6583 10.9512 5.34172 11.1464 5.14646Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Cybersecurity Community",
                desc: "Join a network of security professionals and ethical hackers for knowledge sharing and collaboration."
            },
            {
                id: "6",
                icon: ( <svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M7.28856 0.796908C7.42258 0.734364 7.57742 0.734364 7.71144 0.796908L13.7114 3.59691C13.8875 3.67906 14 3.85574 14 4.05V10.95C14 11.1443 13.8875 11.3209 13.7114 11.4031L7.71144 14.2031C7.57742 14.2656 7.42258 14.2656 7.28856 14.2031L1.28856 11.4031C1.11252 11.3209 1 11.1443 1 10.95V4.05C1 3.85574 1.11252 3.67906 1.28856 3.59691L7.28856 0.796908ZM2 4.80578L7 6.93078V12.9649L2 10.6316V4.80578ZM8 12.9649L13 10.6316V4.80578L8 6.93078V12.9649ZM7.5 6.05672L12.2719 4.02866L7.5 1.80176L2.72809 4.02866L7.5 6.05672Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Cutting-edge Tools",
                desc: "Learn to use industry-standard tools for penetration testing and security assessments."
            },
        ]
       
    },
    {
        id: "4",
        title: "What You'll Learn",
        sub_title:"Gain essential ethical hacking skills to identify, exploit, and secure vulnerabilities in different systems and networks.",
        Course_img: [
            {
                id: "1",
                img: "https://img.freepik.com/premium-photo/hooded-hacker-shopping-online_391052-4468.jpg?w=740",
                title: "Basic of Ethical Hacking",
                alt: "Basic of Ethical Hacking"
            },
            {
                id: "2",
                img: "https://img.freepik.com/premium-photo/smart-law-legal-advice-icons-astute-lawyer-working-tools-lawyers-office_31965-187171.jpg?w=740",
                title: "Laws and Compliance of Cyber Security",
                 alt: "Cyber Security"
            },
            {
                id: "4",
                img: "https://img.freepik.com/free-photo/organized-female-hacker-her-team-stealing-information-from-government-server-using-super-computers_482257-20619.jpg?t=st=1720785171~exp=1720788771~hmac=19494cfbfe537dfc4f4b3fe0e789e59cad976243a3fd0f9cf52ff58541f845e6&w=826",
                title: "Information Security Controls",
                  alt: "Security "
            },
        ]
    },
    {
        id: "5",
        title: "Frequently Asked Questions (FAQs)",
        sub_title: "Still have questions about our CEH Certification course? Here are some common questions to help you out.",
        faqs: [
           {
            id: "1",
            heading: "Who is this course for?",
            sub_heading: "This course is for IT professionals, network administrators, security officers, auditors, and anyone interested in learning ethical hacking.",
           },
           {
            id: "2",
            heading: "What prerequisites are required?",
            sub_heading: "A good understanding of TCP/IP, Linux, and basic Windows server is recommended. You should also be familiar with networking concepts.",
           },
           {
            id: "3",
            heading: "Is the official CEH exam included in the course fee?",
            sub_heading: "The exam voucher is not included in the basic course fee, but we offer packages that cover the exam cost. We’ll also help you with the exam registration process.",
           },
           {
            id: "4",
            heading: "How is the course structured?",
            sub_heading: "The course includes lectures, hands-on labs, and practice tests. You’ll learn various hacking techniques and how to defend against them.",
           },
           {
            id: "5",
            heading: "Are the tools used in the course freely available?",
            sub_heading: "Many tools are open-source, but some may require licenses. We provide all the necessary tools for you to use during the course.",
           },
           {
            id: "6",
            heading: "What job roles can I pursue after getting CEH certified?",
            sub_heading: "CEH certification can lead to roles such as Information Security Analyst, Penetration Tester, Security Consultant, or Cybersecurity Specialist.",
           },
        ]
    }
]
 

export const MobileApplication = [
    {
        id: "1",
        small_text: "Start your career as a Mobile Application Development",
        name: "Mobile Application Development course in kurukshetra",
        duration_One : "6 Months",
        description: "In today’s smartphone-focused world, mobile apps are a vital part of our everyday lives. There’s a rising demand for talented developers who can create innovative and user-friendly apps. At BrainboxStudy, we provide thorough training in Mobile Application Development. Our goal is to help you learn the skills needed to design, build, and launch amazing mobile apps. Join us and bring your ideas to life right in users' hands!",
        image: "/appdevelopment.png",
        alt: "appdevelopment",
        join_btn: "Join Now",
    },
    {
        id: "2",
        main_image: "https://img.freepik.com/free-photo/representations-user-experience-interface-design_23-2150038906.jpg?t=st=1720784540~exp=1720788140~hmac=81919e2fb2a97d4eaf701a31c109302039eeca52c58da337f64155ccd37bd419&w=740",
        small_text_one: "Mobile Application Development Course",
        title: "Mobile Application Development Course in Kurukshetra: Why Choose This Career?",
        desc: "In today's digital world, mobile apps are leading the way in technology across many industries. This career blends creativity with technical skills, letting you create solutions that millions of people use daily. Our Mobile Application Development Course in Kurukshetra is ideal for anyone who wants to be at the forefront of software development and user experience design.Whether you're a coding enthusiast, a recent graduate, or a professional looking to switch to mobile development, this field offers exciting opportunities. You'll work on various projects, keep learning about new technologies, and see your apps used by people around the world. As businesses focus more on mobile strategies, mobile app developers are essential in shaping digital experiences and driving success.",
        visit_btn: " Visit the help center"
    },
    {
        id: "3",
        title: "Why Choose BrainboxStudy for Mobile Application Development?",
        sub_title: "Start your journey to becoming a skilled mobile app developer with our industry-focused courses.",
        feature: [
            {
                id: "1",
                icon: ( <svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M0.849976 1.74998C0.849976 1.25292 1.25292 0.849976 1.74998 0.849976H3.24998C3.74703 0.849976 4.14998 1.25292 4.14998 1.74998V2.04998H10.85V1.74998C10.85 1.25292 11.2529 0.849976 11.75 0.849976H13.25C13.747 0.849976 14.15 1.25292 14.15 1.74998V3.24998C14.15 3.74703 13.747 4.14998 13.25 4.14998H12.95V10.85H13.25C13.747 10.85 14.15 11.2529 14.15 11.75V13.25C14.15 13.747 13.747 14.15 13.25 14.15H11.75C11.2529 14.15 10.85 13.747 10.85 13.25V12.95H4.14998V13.25C4.14998 13.747 3.74703 14.15 3.24998 14.15H1.74998C1.25292 14.15 0.849976 13.747 0.849976 13.25V11.75C0.849976 11.2529 1.25292 10.85 1.74998 10.85H2.04998V4.14998H1.74998C1.25292 4.14998 0.849976 3.74703 0.849976 3.24998V1.74998ZM2.94998 4.14998V10.85H3.24998C3.74703 10.85 4.14998 11.2529 4.14998 11.75V12.05H10.85V11.75C10.85 11.2529 11.2529 10.85 11.75 10.85H12.05V4.14998H11.75C11.2529 4.14998 10.85 3.74703 10.85 3.24998V2.94998H4.14998V3.24998C4.14998 3.74703 3.74703 4.14998 3.24998 4.14998H2.94998ZM2.34998 1.74998H1.74998V2.34998V2.64998V3.24998H2.34998H2.64998H3.24998V2.64998V2.34998V1.74998H2.64998H2.34998ZM5.09998 5.99998C5.09998 5.50292 5.50292 5.09998 5.99998 5.09998H6.99998C7.49703 5.09998 7.89998 5.50292 7.89998 5.99998V6.99998C7.89998 7.03591 7.89787 7.07134 7.89378 7.10618C7.92861 7.10208 7.96405 7.09998 7.99998 7.09998H8.99998C9.49703 7.09998 9.89998 7.50292 9.89998 7.99998V8.99998C9.89998 9.49703 9.49703 9.89998 8.99998 9.89998H7.99998C7.50292 9.89998 7.09998 9.49703 7.09998 8.99998V7.99998C7.09998 7.96405 7.10208 7.92861 7.10618 7.89378C7.07134 7.89787 7.03591 7.89998 6.99998 7.89998H5.99998C5.50292 7.89998 5.09998 7.49703 5.09998 6.99998V5.99998ZM6.09998 5.99998H5.99998V6.09998V6.89998V6.99998H6.09998H6.89998H6.99998V6.89998V6.09998V5.99998H6.89998H6.09998ZM7.99998 7.99998H8.09998H8.89998H8.99998V8.09998V8.89998V8.99998H8.89998H8.09998H7.99998V8.89998V8.09998V7.99998ZM2.64998 11.75H2.34998H1.74998V12.35V12.65V13.25H2.34998H2.64998H3.24998V12.65V12.35V11.75H2.64998ZM11.75 1.74998H12.35H12.65H13.25V2.34998V2.64998V3.24998H12.65H12.35H11.75V2.64998V2.34998V1.74998ZM12.65 11.75H12.35H11.75V12.35V12.65V13.25H12.35H12.65H13.25V12.65V12.35V11.75H12.65Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Expert Instructors",
                desc: " Learn from experienced developers who have successfully launched apps."
            },
            {
                id: "2",
                icon: ( <svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M3.00014 2.73895C3.00014 2.94698 2.76087 3.06401 2.59666 2.93628L1.00386 1.69744C0.875177 1.59735 0.875177 1.40286 1.00386 1.30277L2.59666 0.063928C2.76087 -0.0637944 3.00014 0.0532293 3.00014 0.261266V1.00012H9.00009V0.261296C9.00009 0.0532591 9.23936 -0.0637646 9.40358 0.0639578L10.9964 1.3028C11.1251 1.40289 11.1251 1.59738 10.9964 1.69747L9.40358 2.93631C9.23936 3.06404 9.00009 2.94701 9.00009 2.73898V2.00012H3.00014V2.73895ZM9.50002 4.99998H2.50002C2.22388 4.99998 2.00002 5.22384 2.00002 5.49998V12.5C2.00002 12.7761 2.22388 13 2.50002 13H9.50002C9.77616 13 10 12.7761 10 12.5V5.49998C10 5.22384 9.77616 4.99998 9.50002 4.99998ZM2.50002 3.99998C1.67159 3.99998 1.00002 4.67156 1.00002 5.49998V12.5C1.00002 13.3284 1.67159 14 2.50002 14H9.50002C10.3284 14 11 13.3284 11 12.5V5.49998C11 4.67156 10.3284 3.99998 9.50002 3.99998H2.50002ZM14.7389 6.00001H14V12H14.7389C14.9469 12 15.064 12.2393 14.9362 12.4035L13.6974 13.9963C13.5973 14.125 13.4028 14.125 13.3027 13.9963L12.0639 12.4035C11.9362 12.2393 12.0532 12 12.2612 12H13V6.00001H12.2612C12.0532 6.00001 11.9361 5.76074 12.0639 5.59653L13.3027 4.00373C13.4028 3.87505 13.5973 3.87505 13.6974 4.00374L14.9362 5.59653C15.0639 5.76074 14.9469 6.00001 14.7389 6.00001Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Hands-on Curriculum",
                desc: "Gain practical skills through real-world projects and development challenges."
            },
            {
                id: "3",
                icon: (<svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M1 2C0.447715 2 0 2.44772 0 3V12C0 12.5523 0.447715 13 1 13H14C14.5523 13 15 12.5523 15 12V3C15 2.44772 14.5523 2 14 2H1ZM1 3L14 3V3.92494C13.9174 3.92486 13.8338 3.94751 13.7589 3.99505L7.5 7.96703L1.24112 3.99505C1.16621 3.94751 1.0826 3.92486 1 3.92494V3ZM1 4.90797V12H14V4.90797L7.74112 8.87995C7.59394 8.97335 7.40606 8.97335 7.25888 8.87995L1 4.90797Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Multi-Platform Focus",
                desc: "Master both Android and iOS development, as well as cross-platform frameworks."
            },
            {
                id: "4",
                icon: ( <svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M4.5 2C3.11929 2 2 3.11929 2 4.5C2 5.88072 3.11929 7 4.5 7C5.88072 7 7 5.88072 7 4.5C7 3.11929 5.88072 2 4.5 2ZM3 4.5C3 3.67157 3.67157 3 4.5 3C5.32843 3 6 3.67157 6 4.5C6 5.32843 5.32843 6 4.5 6C3.67157 6 3 5.32843 3 4.5ZM10.5 2C9.11929 2 8 3.11929 8 4.5C8 5.88072 9.11929 7 10.5 7C11.8807 7 13 5.88072 13 4.5C13 3.11929 11.8807 2 10.5 2ZM9 4.5C9 3.67157 9.67157 3 10.5 3C11.3284 3 12 3.67157 12 4.5C12 5.32843 11.3284 6 10.5 6C9.67157 6 9 5.32843 9 4.5ZM2 10.5C2 9.11929 3.11929 8 4.5 8C5.88072 8 7 9.11929 7 10.5C7 11.8807 5.88072 13 4.5 13C3.11929 13 2 11.8807 2 10.5ZM4.5 9C3.67157 9 3 9.67157 3 10.5C3 11.3284 3.67157 12 4.5 12C5.32843 12 6 11.3284 6 10.5C6 9.67157 5.32843 9 4.5 9ZM10.5 8C9.11929 8 8 9.11929 8 10.5C8 11.8807 9.11929 13 10.5 13C11.8807 13 13 11.8807 13 10.5C13 9.11929 11.8807 8 10.5 8ZM9 10.5C9 9.67157 9.67157 9 10.5 9C11.3284 9 12 9.67157 12 10.5C12 11.3284 11.3284 12 10.5 12C9.67157 12 9 11.3284 9 10.5Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Career Support",
                desc: " Get job placement assistance, help with building your portfolio, and connections in the industry."
            },
            {
                id: "5",
                icon: (<svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M9.96424 2.68571C10.0668 2.42931 9.94209 2.13833 9.6857 2.03577C9.4293 1.93322 9.13832 2.05792 9.03576 2.31432L5.03576 12.3143C4.9332 12.5707 5.05791 12.8617 5.3143 12.9642C5.5707 13.0668 5.86168 12.9421 5.96424 12.6857L9.96424 2.68571ZM3.85355 5.14646C4.04882 5.34172 4.04882 5.6583 3.85355 5.85356L2.20711 7.50001L3.85355 9.14646C4.04882 9.34172 4.04882 9.6583 3.85355 9.85356C3.65829 10.0488 3.34171 10.0488 3.14645 9.85356L1.14645 7.85356C0.951184 7.6583 0.951184 7.34172 1.14645 7.14646L3.14645 5.14646C3.34171 4.9512 3.65829 4.9512 3.85355 5.14646ZM11.1464 5.14646C11.3417 4.9512 11.6583 4.9512 11.8536 5.14646L13.8536 7.14646C14.0488 7.34172 14.0488 7.6583 13.8536 7.85356L11.8536 9.85356C11.6583 10.0488 11.3417 10.0488 11.1464 9.85356C10.9512 9.6583 10.9512 9.34172 11.1464 9.14646L12.7929 7.50001L11.1464 5.85356C10.9512 5.6583 10.9512 5.34172 11.1464 5.14646Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "Developer Community",
                desc: "Join a network of aspiring and professional app developers for collaboration and sharing ideas."
            },
            {
                id: "6",
                icon: ( <svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      d="M7.28856 0.796908C7.42258 0.734364 7.57742 0.734364 7.71144 0.796908L13.7114 3.59691C13.8875 3.67906 14 3.85574 14 4.05V10.95C14 11.1443 13.8875 11.3209 13.7114 11.4031L7.71144 14.2031C7.57742 14.2656 7.42258 14.2656 7.28856 14.2031L1.28856 11.4031C1.11252 11.3209 1 11.1443 1 10.95V4.05C1 3.85574 1.11252 3.67906 1.28856 3.59691L7.28856 0.796908ZM2 4.80578L7 6.93078V12.9649L2 10.6316V4.80578ZM8 12.9649L13 10.6316V4.80578L8 6.93078V12.9649ZM7.5 6.05672L12.2719 4.02866L7.5 1.80176L2.72809 4.02866L7.5 6.05672Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    />
                  </svg>),
                title: "App Testing Lab",
                desc: "Use our device lab to test your apps on various smartphones and tablets."
            },
        ]
       
    },
    {
        id: "4",
        title: "What You'll Learn",
        sub_title:"Gain essential skills and tools to develop strong, user-friendly mobile apps for both Android and iOS platforms.",
        Course_img: [
            {
                id: "1",
                img: "https://img.freepik.com/free-vector/app-development-illustration_52683-47931.jpg?t=st=1720784638~exp=1720788238~hmac=ebc2ae269c823d07abede1574836767eba9a2d04de1a841bfeb2caa739bff6a5&w=740",
                title: "flutter",
                alt: "flutter"
            },
            {
                id: "2",
                img: "https://img.freepik.com/free-vector/react-native-mobile-app-abstract-concept-illustration-cross-platform-native-mobile-app-development-framework-javascript-library-user-interface-operating-system_335657-3350.jpg?t=st=1720784716~exp=1720788316~hmac=a1b71ed9f0795f5c211fb2dccb75e282c556a849193bdee3c7392425b2b55389&w=740",
                title: "react native",
                alt: "react native"
            },
            {
                id: "4",
                img: "https://www.simplilearn.com/ice9/free_resources_article_thumb/How_to_Become_an_Android_Developer.jpg",
                title: "Anriod",
                  alt: "Anriod"
            },
        ]
    },
    {
        id: "5",
        title: "Frequently Asked Questions (FAQs)",
        sub_title: "Still have questions about our Mobile Application Development course? Here are some common ones.",
        faqs: [
           {
            id: "1",
            heading: "Who is this course suitable for?",
            sub_heading: "This course is for anyone with basic programming knowledge, as well as experienced developers wanting to focus on mobile app development.",
           },
           {
            id: "2",
            heading: "What programming languages will I learn?",
            sub_heading: "You’ll learn Java and Kotlin for Android development, Swift for iOS development, and frameworks like React Native for cross-platform development.",
           },
           {
            id: "3",
            heading: "Do I need a Mac to develop iOS apps?",
            sub_heading: "Having a Mac is ideal for iOS development, but we provide cloud-based Mac environments for students without access to Apple hardware.",
           },
           {
            id: "4",
            heading: "Will I be able to publish my own app by the end of the course?",
            sub_heading: "Yes! You’ll complete a capstone project where you’ll create your own app from start to finish and publish it on app stores.",
           },
           {
            id: "5",
            heading: "Are there opportunities for internships or real-world projects?",
            sub_heading: "Yes, we partner with local businesses and startups, so top-performing students may get to work on real client projects.",
           },
           {
            id: "6",
            heading: "What kind of apps will I learn to build?",
            sub_heading: "You’ll learn to build a variety of apps, including social media, e-commerce, productivity tools, and games. We also explore new areas like AR and IoT integration.",
           },
        ]
    }
]
 